//#region src/adapters/static/footer.ts
const footer = {
	entity: "Pleo North America, Inc.",
	address: [{
		type: "paragraph",
		text: "18th Ave S & Chet Atkins Pl",
		spans: []
	}, {
		type: "paragraph",
		text: "Nashville, TN 37212",
		spans: []
	}],
	terms_body: "Pleo Mastercard® Prepaid Card is issued by Pathward® N.A., Member FDIC, pursuant to a license from Mastercard International Incorporated. Accepted for use anywhere Debit Mastercard is accepted. No cash access. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated.",
	copyright_text: "All rights reserved.",
	financial_partner_terms_text: null,
	financial_partner_copyright_text: null,
	contact_us: "Chat with us",
	sales_email: null,
	info_email: null,
	support_email: null,
	product_heading: "Product",
	resources_heading: "Resources",
	company_heading: "Company",
	legal_heading: "Legal",
	solutions_heading: "Solutions",
	partnerships_heading: null,
	product_links: [{
		text: "Status",
		link: {
			link_type: "Web",
			uid: null,
			type: null,
			lang: null,
			target: null,
			url: "https://status.pleo.io/"
		}
	}],
	resources_links: [{
		text: "Help Centre",
		link: {
			link_type: "Web",
			uid: null,
			type: null,
			lang: null,
			target: null,
			url: "https://help.pleo.io/en/"
		}
	}, {
		text: "Developers",
		link: {
			link_type: "Web",
			uid: null,
			type: null,
			lang: null,
			target: null,
			url: "https://developers.pleo.io/reference/introduction"
		}
	}],
	company_links: [{
		text: "Careers",
		link: {
			link_type: "Web",
			uid: null,
			type: null,
			lang: null,
			target: null,
			url: "https://www.pleo.io/en/careers"
		}
	}, {
		text: "Legal",
		link: {
			link_type: "Document",
			uid: null,
			type: "legal_page",
			lang: "en-us",
			target: null,
			url: "/us/legal"
		}
	}],
	legal_links: [
		{
			text: "Cardholder Agreement",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "/us/legal"
			}
		},
		{
			text: "Master Service Agreement",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "/us/legal"
			}
		},
		{
			text: "Privacy Policy",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "/us/legal"
			}
		},
		{
			text: "Fraud awareness",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://www.pleo.io/legal-documents/pleo-fraud-awareness-us.pdf"
			}
		},
		{
			text: "Complaints process",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://www.pleo.io/legal-documents/pleo-complaint-process-na.pdf"
			}
		},
		{
			text: "Code of Conduct",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://www.pleo.io/en/code-of-conduct"
			}
		}
	],
	solutions_links: [],
	partnerships_links: []
};
//#endregion
//#region src/adapters/static/header.ts
const header = {
	start_free_trial: "Get started",
	book_a_demo: null,
	log_in: "Log in",
	explore: "Explore",
	explore_product: "Explore product",
	explore_partner_portal: "",
	app_link_text: "Go to App",
	dropdowns: [
		{
			label: "Product",
			link: {
				link_type: "Any",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: null
			},
			show_badge: false,
			hide_on: "tablet",
			dropdown: { document: { data: {
				columns: [{ column: { document: {
					id: "bb153063-cdc2-5547-aebe-85914d361887",
					data: {
						icon: {
							alt: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/51570409-7fb2-4c1b-983a-3480904180d8_buy-something-icon.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							copyright: null,
							dimensions: {
								height: 50,
								width: 50
							}
						},
						label: "Features",
						links: [{
							link_text: "Business expense cards",
							link: {
								link_type: "Document",
								uid: "business-expense-cards",
								type: "slice_page",
								lang: "en-us",
								target: null,
								url: "/us/business-expense-cards"
							}
						}, {
							link_text: "Expense management",
							link: {
								link_type: "Document",
								uid: "howitworks",
								type: "slice_page",
								lang: "en-us",
								target: null,
								url: "/us/howitworks"
							}
						}]
					}
				} } }, { column: { document: {
					id: "968930b9-d018-5272-b313-268e912f3391",
					data: {
						icon: {
							alt: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/374847a0-be2c-428b-9d7c-d6514e07e786_Vector.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							copyright: null,
							dimensions: {
								height: 29,
								width: 30
							}
						},
						label: "Why Pleo?",
						links: [{
							link_text: "Overview",
							link: {
								link_type: "Document",
								uid: "features",
								type: "slice_page",
								lang: "en-us",
								target: null,
								url: "/us/features"
							}
						}, {
							link_text: "Spend controls",
							link: {
								link_type: "Document",
								uid: "spend-controls",
								type: "slice_page",
								lang: "en-us",
								target: null,
								url: "/us/spend-controls"
							}
						}]
					}
				} } }],
				cta_column: { document: { data: {
					background_color: "pink",
					body: "See how easy it is to manage your team's expenses in Pleo",
					cta_text: "Explore product",
					cta_link: {
						link_type: "Document",
						uid: "explore-product",
						type: "explore_product",
						lang: "en-us",
						target: null,
						url: "/us/explore-product"
					},
					image: {
						alt: null,
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/069ff477-adc9-400d-ab62-8e38123bb48f_explore-product-icon.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						copyright: null,
						dimensions: {
							height: 80,
							width: 80
						}
					}
				} } }
			} } }
		},
		{
			label: "Pricing",
			link: {
				link_type: "Document",
				uid: "pricing",
				type: "pricing_page",
				lang: "en-us",
				target: null,
				url: "/us/pricing"
			},
			show_badge: false,
			hide_on: "tablet",
			dropdown: { document: null }
		},
		{
			label: "Pricing Plans",
			link: {
				link_type: "Any",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: null
			},
			show_badge: false,
			hide_on: "all",
			dropdown: { document: { data: { columns: [{ column: { document: { data: {
				label: "Pricing",
				links: [{
					link_text: "Pricing Plans",
					link: { url: "/us/pricing" }
				}]
			} } } }] } } }
		}
	]
};
//#endregion
//#region src/adapters/static/slice-page.ts
const howitworksData = {
	track_visible_sections: null,
	hide_left_nav: false,
	hide_right_nav: false,
	hide_links: false,
	header_cta_destination: "signupform",
	meta_title: "Automated expense management system | Pleo",
	meta_description: "Automate expense management with Pleo’s software and smart app. Take full control of your business and employee spend with one online expense system.",
	exclude_robots: false,
	open_graph_image: {
		alt: "Employee enjoys the benefit of the automated expense management software",
		copyright: null,
		url: "https://images.prismic.io/commercial-helios/c491d260-34fb-4366-a58e-7b27e81a552b_automated-expense-management-pleo.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
		dimensions: {
			height: 2751,
			width: 2501
		}
	},
	body: [
		{
			__typename: "PrismicSlicePageDataBodyHero",
			primary: {
				section_html_id: null,
				title: "Europe's leading tool for automated expense management",
				inverse: false,
				is_oversized_image: false,
				lead_text: { richText: [{
					type: "paragraph",
					text: "Stop spending time on expenses and do more of the work that matters. Switch to Pleo’s expense management system and take the stress out of business spending.",
					spans: []
				}] },
				image: {
					alt: null,
					copyright: null,
					url: "https://images.prismic.io/commercial-helios/d83c7e43-4dab-4701-a3e3-40db8e2ca12b_exports-for-espense-management-site-hero-EUR-ENG.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 1320,
						width: 1200
					},
					gatsbyImageData: {
						images: {
							sources: [],
							fallback: {
								src: "https://images.prismic.io/commercial-helios/d83c7e43-4dab-4701-a3e3-40db8e2ca12b_exports-for-espense-management-site-hero-EUR-ENG.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
								srcSet: "https://images.prismic.io/commercial-helios/d83c7e43-4dab-4701-a3e3-40db8e2ca12b_exports-for-espense-management-site-hero-EUR-ENG.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/d83c7e43-4dab-4701-a3e3-40db8e2ca12b_exports-for-espense-management-site-hero-EUR-ENG.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/d83c7e43-4dab-4701-a3e3-40db8e2ca12b_exports-for-espense-management-site-hero-EUR-ENG.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/d83c7e43-4dab-4701-a3e3-40db8e2ca12b_exports-for-espense-management-site-hero-EUR-ENG.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
								sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
							}
						},
						layout: "constrained",
						width: 1200,
						height: 1320
					}
				},
				wistia_video_id: null,
				video_mp4: { url: null },
				video_webm: { url: null },
				predefined_signup_banner: {
					type: null,
					document: null
				},
				predefined_proof_point_badges: { document: null }
			}
		},
		{
			__typename: "PrismicSlicePageDataBodySteps",
			primary: {
				title: "Save over 138 hours on expenses each year",
				description: { richText: [{
					type: "paragraph",
					text: "Say goodbye to time-consuming expense reports and manual errors.",
					spans: []
				}] },
				show_count: false,
				cta_link: {
					link_type: "Any",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: null
				},
				cta_text: null
			},
			items: [
				{
					heading: "Automate expense reports",
					content: "Every time your team buys something using Pleo, they'll be instantly asked to capture the receipt in our app. No more 'who bought this?' or manic receipt chasing at the end of the month.",
					background_color: "muted",
					image: {
						alt: "Automate expense reports",
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/f0fde74c-4a0a-46bc-85e1-f5e285fd0b75_us-1.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1058,
							width: 1180
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/f0fde74c-4a0a-46bc-85e1-f5e285fd0b75_us-1.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1058",
									srcSet: "https://images.prismic.io/commercial-helios/f0fde74c-4a0a-46bc-85e1-f5e285fd0b75_us-1.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=646 720w,\nhttps://images.prismic.io/commercial-helios/f0fde74c-4a0a-46bc-85e1-f5e285fd0b75_us-1.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=843 940w,\nhttps://images.prismic.io/commercial-helios/f0fde74c-4a0a-46bc-85e1-f5e285fd0b75_us-1.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=968 1080w,\nhttps://images.prismic.io/commercial-helios/f0fde74c-4a0a-46bc-85e1-f5e285fd0b75_us-1.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1058 1180w",
									sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
								}
							},
							layout: "constrained",
							width: 1180,
							height: 1058
						}
					}
				},
				{
					heading: "Track spending in real-time",
					content: "From daily business expenses to software subscriptions, get instant visibility of all your company spend with our reports. Review the details in real-time, and if something's missing, ask for more information in just a few clicks.",
					background_color: "muted",
					image: {
						alt: "Track spending in real-time",
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/cf87fac5-e751-4942-82ea-040f6f4225d9_us-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1058,
							width: 1180
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/cf87fac5-e751-4942-82ea-040f6f4225d9_us-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1058",
									srcSet: "https://images.prismic.io/commercial-helios/cf87fac5-e751-4942-82ea-040f6f4225d9_us-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=646 720w,\nhttps://images.prismic.io/commercial-helios/cf87fac5-e751-4942-82ea-040f6f4225d9_us-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=843 940w,\nhttps://images.prismic.io/commercial-helios/cf87fac5-e751-4942-82ea-040f6f4225d9_us-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=968 1080w,\nhttps://images.prismic.io/commercial-helios/cf87fac5-e751-4942-82ea-040f6f4225d9_us-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1058 1180w",
									sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
								}
							},
							layout: "constrained",
							width: 1180,
							height: 1058
						}
					}
				},
				{
					heading: "Manage your expenses with Pleo",
					content: "Pleo handles much more than just company card expenses.",
					background_color: "muted",
					image: {
						alt: "Manage your expenses with Pleo",
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/40a028b8-0515-4dcf-92f6-cd38bc3f0843_us-4.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1058,
							width: 1180
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/40a028b8-0515-4dcf-92f6-cd38bc3f0843_us-4.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1058",
									srcSet: "https://images.prismic.io/commercial-helios/40a028b8-0515-4dcf-92f6-cd38bc3f0843_us-4.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=646 720w,\nhttps://images.prismic.io/commercial-helios/40a028b8-0515-4dcf-92f6-cd38bc3f0843_us-4.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=843 940w,\nhttps://images.prismic.io/commercial-helios/40a028b8-0515-4dcf-92f6-cd38bc3f0843_us-4.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=968 1080w,\nhttps://images.prismic.io/commercial-helios/40a028b8-0515-4dcf-92f6-cd38bc3f0843_us-4.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1058 1180w",
									sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
								}
							},
							layout: "constrained",
							width: 1180,
							height: 1058
						}
					}
				},
				{
					heading: "Sync Pleo with your favourite tool",
					content: "Minimise human errors and avoid manual expense reports. Export Pleo spending data right into Quickbooks",
					background_color: "muted",
					image: {
						alt: "Sync Pleo with your favourite tool",
						copyright: null,
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/44890cc7-dde7-448e-89a5-d67212515eff_us-3.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 529,
							width: 590
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://commercial-helios.cdn.prismic.io/commercial-helios/44890cc7-dde7-448e-89a5-d67212515eff_us-3.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=590&h=529",
									srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/44890cc7-dde7-448e-89a5-d67212515eff_us-3.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=590&h=529 590w",
									sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
								}
							},
							layout: "constrained",
							width: 590,
							height: 529
						}
					}
				}
			]
		},
		{
			__typename: "PrismicSlicePageDataBodyFeatureBlock",
			primary: {
				title_over_section: null,
				title: "Take control of your company finances",
				inverse: false,
				background: "default",
				headline: null,
				description: { richText: [{
					type: "paragraph",
					text: "Spot new ways to save thanks to full visibility of your business spend. Set individual card spending limits, expense review thresholds and assign team managers as reviewers. With Pleo, you can build a spending culture that’s based on trust and responsibility. ",
					spans: []
				}] },
				pre_cta_links: { richText: [] },
				is_circular_image: false,
				cta_label: null,
				predefined_feature_block: { document: null },
				cta_link: {
					link_type: "Any",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: null
				},
				cta_hash_link: null,
				image: {
					alt: null,
					copyright: null,
					url: "https://images.prismic.io/commercial-helios/8d5250fa-4b87-467e-88ac-8e4569549b7e_Take-control-of-your-company-finances-ENG-EUR.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 1200,
						width: 1200
					},
					gatsbyImageData: {
						images: {
							sources: [],
							fallback: {
								src: "https://images.prismic.io/commercial-helios/8d5250fa-4b87-467e-88ac-8e4569549b7e_Take-control-of-your-company-finances-ENG-EUR.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200",
								srcSet: "https://images.prismic.io/commercial-helios/8d5250fa-4b87-467e-88ac-8e4569549b7e_Take-control-of-your-company-finances-ENG-EUR.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=720 720w,\nhttps://images.prismic.io/commercial-helios/8d5250fa-4b87-467e-88ac-8e4569549b7e_Take-control-of-your-company-finances-ENG-EUR.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=940 940w,\nhttps://images.prismic.io/commercial-helios/8d5250fa-4b87-467e-88ac-8e4569549b7e_Take-control-of-your-company-finances-ENG-EUR.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1080 1080w,\nhttps://images.prismic.io/commercial-helios/8d5250fa-4b87-467e-88ac-8e4569549b7e_Take-control-of-your-company-finances-ENG-EUR.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200 1200w",
								sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
							}
						},
						layout: "constrained",
						width: 1200,
						height: 1200
					}
				},
				wistia_video_id: null,
				video_mp4: { url: null },
				video_webm: { url: null }
			}
		},
		{
			__typename: "PrismicSlicePageDataBodyStats",
			primary: {
				first_stat_amount: 72,
				first_stat_text: "feel they have a better overview of how company money is being spent",
				first_stat_as_percentile: true,
				second_stat_amount: 75,
				second_stat_text: "agree Pleo has decreased time spent on admin work",
				second_stat_as_percentile: true,
				third_stat_amount: 68,
				third_stat_text: "feel that using Pleo has increased transparency",
				third_stat_as_percentile: true,
				source_text: { richText: [] },
				predefined_statistics: { document: null }
			}
		},
		{
			__typename: "PrismicSlicePageDataBodyMediaItemGrid",
			primary: {
				title: "Same spending, but simple",
				layout: "two_columns",
				background: "muted"
			},
			items: [{
				image: {
					alt: null,
					copyright: null,
					url: "https://commercial-helios.cdn.prismic.io/commercial-helios/d6ecdd3c-2347-495a-9afb-637ce998db6b_Day-to-day%20expenses.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 100,
						width: 100
					}
				},
				item_title: "Day-to-day expenses",
				item_description: { richText: [{
					type: "paragraph",
					text: "From client meals to office supplies - get a grip on your business expenses and forget about missing receipts when they’re managed with Pleo.",
					spans: []
				}] }
			}, {
				image: {
					alt: null,
					copyright: null,
					url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a870bedb-1546-4445-a8a2-b04e9cc78d9b_Business%20travel%20spend.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 100,
						width: 100
					}
				},
				item_title: "Business travel spend",
				item_description: { richText: [{
					type: "paragraph",
					text: "Pleo company cards work wherever your team goes. Our handy app means they’ve got reliable travel expense management software on-the-go. ",
					spans: []
				}] }
			}]
		},
		{
			__typename: "PrismicSlicePageDataBodyFeatureGrid",
			primary: {
				title: "Trusted by businesses of all sizes",
				background: "default"
			},
			items: [
				{
					image: {
						alt: null,
						copyright: null,
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/3d7e82dc-ad8c-497c-8967-4a4587610e84_expense%20management_for%20startups-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 150,
							width: 210
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://commercial-helios.cdn.prismic.io/commercial-helios/3d7e82dc-ad8c-497c-8967-4a4587610e84_expense%20management_for%20startups-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150",
									srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/3d7e82dc-ad8c-497c-8967-4a4587610e84_expense%20management_for%20startups-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150 210w",
									sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
								}
							},
							layout: "constrained",
							width: 210,
							height: 150
						}
					},
					feature_title: "For startups",
					feature_description: { richText: [{
						type: "paragraph",
						text: "Boost your company culture by giving your employees autonomous spending solutions without compromising on control and visibility. ",
						spans: []
					}] },
					predefined_feature: { document: null }
				},
				{
					image: {
						alt: null,
						copyright: null,
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/201f64c5-ba29-4928-8956-66403d090796_expense%20management_for%20medium%20companies-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 150,
							width: 210
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://commercial-helios.cdn.prismic.io/commercial-helios/201f64c5-ba29-4928-8956-66403d090796_expense%20management_for%20medium%20companies-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150",
									srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/201f64c5-ba29-4928-8956-66403d090796_expense%20management_for%20medium%20companies-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150 210w",
									sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
								}
							},
							layout: "constrained",
							width: 210,
							height: 150
						}
					},
					feature_title: "For small businesses",
					feature_description: { richText: [{
						type: "paragraph",
						text: "Forget about manual expense reports and missing receipts thanks to an automated  solution loved by employees and bookkeepers alike.",
						spans: []
					}] },
					predefined_feature: { document: null }
				},
				{
					image: {
						alt: null,
						copyright: null,
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/5b168b4f-2892-495a-a838-8dc6f332fd3e_expense%20management_for%20big%20businesses-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 150,
							width: 210
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://commercial-helios.cdn.prismic.io/commercial-helios/5b168b4f-2892-495a-a838-8dc6f332fd3e_expense%20management_for%20big%20businesses-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150",
									srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/5b168b4f-2892-495a-a838-8dc6f332fd3e_expense%20management_for%20big%20businesses-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150 210w",
									sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
								}
							},
							layout: "constrained",
							width: 210,
							height: 150
						}
					},
					feature_title: "For large businesses",
					feature_description: { richText: [{
						type: "paragraph",
						text: "Empower your finance team to manage  expenses through a single Pleo account, no matter how many entities you have or where your offices are based. ",
						spans: []
					}] },
					predefined_feature: { document: null }
				}
			]
		},
		{
			__typename: "PrismicSlicePageDataBodySocialProof",
			primary: {
				title: null,
				inverse: false
			},
			items: [{
				image: {
					alt: null,
					copyright: null,
					url: null,
					dimensions: null,
					gatsbyImageData: null
				},
				quote: null,
				full_name: null,
				person_byline: null,
				predefined_testimonial: { document: { data: {
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 2240,
							width: 2400
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240",
									srcSet: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=672 720w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=877 940w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1008 1080w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1440&h=1344 1440w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240 2400w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 2400,
							height: 2240
						}
					},
					quote: "We used to spend around 10% of our time on credit card reconciliations a month, and thanks to Pleo this has been reduced to around 2%.",
					attribution_name: "Charlie Maynard",
					attribution_title: "Finance Manager, what3words"
				} } }
			}]
		},
		{
			__typename: "PrismicSlicePageDataBodyRatingsPlusHeadline",
			primary: {
				ratings_title: { richText: [] },
				ratings_lead_text: null,
				ratings_cta_text: null,
				cta_link: {
					link_type: "Any",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: null
				},
				predefined_ratings: { document: { data: {
					title: { richText: [{
						type: "paragraph",
						text: "Highly rated in all the right places",
						spans: []
					}] },
					lead_text: null,
					cta_text: null,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					ratings: [
						{ rating: { document: { data: {
							logo: {
								alt: "Trustpilot logo",
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/8d4b66a1-bbec-4ead-b3c3-01f0995f65a8_trustpilot-vector-logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 148,
									width: 601
								}
							},
							rating_number: 4,
							link: "https://www.trustpilot.com/review/pleo.io"
						} } } },
						{ rating: { document: { data: {
							logo: {
								alt: "G2 logo",
								copyright: "é",
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a49767c4-88c2-4b6f-ae3c-b236df9fbce6_G2_Logo_Red_RGB.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 150
								}
							},
							rating_number: 4.8,
							link: "https://www.g2.com/products/pleo/reviews"
						} } } },
						{ rating: { document: { data: {
							logo: {
								alt: "Capterra logo",
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/ac82880a-40b6-43b9-975f-2f5d44310463_capterralogo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 345,
									width: 1500
								}
							},
							rating_number: 4.9,
							link: "https://www.capterra.com/p/160720/Pleo"
						} } } }
					]
				} } }
			},
			items: [{ rating: { document: null } }]
		},
		{
			__typename: "PrismicSlicePageDataBodyFaq",
			primary: {
				title: "Questions? We got you",
				collapsible: false
			},
			items: [
				{
					question: "What is Pleo?",
					answer: { richText: [{
						type: "paragraph",
						text: "Pleo is a fundamentally new way to manage business spending, using expense automation to transform how companies spend. Pleo takes the stress and friction out of expenses – empowering employees and managers at the same time. Employees use their company card to buy what they need for work and finance teams can see in real-time where company money is going.",
						spans: []
					}] },
					image: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					},
					icon: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					}
				},
				{
					question: "What is meant by expense management?",
					answer: { richText: [{
						type: "paragraph",
						text: "Expense management refers to the tools and processes companies use to pay and report on employee spending. That's everything from business travel costs to client lunches and software subscriptions.\n\nWhen managed manually, expenses can take hours for both employees and finance teams to report, fill in the claims and reconcile. Automated expense management systems like Pleo help businesses save time and increase spend visibility. Employees can easily submit new company card or out-of-pocket expenses and finance teams can review them in real-time, making sure there’s accountability and adherence to your company expense policy.",
						spans: []
					}] },
					image: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					},
					icon: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					}
				},
				{
					question: "Why is expense management important?",
					answer: { richText: [{
						type: "paragraph",
						text: "Business expense management is important to make sure employee-initiated expenses are in-line with the company policy as well as don’t exceed the projected business spend. Using automated expense management systems, businesses have accurate, real-time spending data which helps to avoid manual reporting mistakes, making bookkeeping faster and boosting compliance.",
						spans: []
					}] },
					image: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					},
					icon: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					}
				},
				{
					question: "How do Pleo cards work?",
					answer: { richText: [
						{
							type: "paragraph",
							text: "We issue virtual business cards as soon as you sign up. Just download our Pleo business expense app and you can see the details for your virtual card. It can be used for online purchases and subscriptions.\xA0",
							spans: []
						},
						{
							type: "paragraph",
							text: "",
							spans: []
						},
						{
							type: "paragraph",
							text: "When you sign up, we’ll also order physical Pleo cards for you. These can be used for in-store purchases made on-the-go, including contactless transactions.",
							spans: []
						}
					] },
					image: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					},
					icon: {
						dimensions: null,
						alt: null,
						copyright: null,
						url: null
					}
				}
			]
		}
	]
};
const slicePage = [
	{
		uid: "business-expense-cards",
		slices: [
			{
				__typename: "PrismicSlicePageDataBodyHero",
				primary: {
					section_html_id: null,
					title: "The only business expense card you need",
					inverse: false,
					is_oversized_image: false,
					lead_text: { richText: [{
						type: "paragraph",
						text: "Pleo makes spending easy, whether you’re paying for business travel, employee or project expenses or subscriptions. With over 50+ currencies, Pleo cards help you control your finances while earning cashback. Plus, get your first 2 Pleo cards for free!",
						spans: []
					}] },
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/23614c9f-2f3f-4cc6-b891-e7c96b41ce43_01_Business-Expense-Cards-Hero.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/23614c9f-2f3f-4cc6-b891-e7c96b41ce43_01_Business-Expense-Cards-Hero.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/23614c9f-2f3f-4cc6-b891-e7c96b41ce43_01_Business-Expense-Cards-Hero.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/23614c9f-2f3f-4cc6-b891-e7c96b41ce43_01_Business-Expense-Cards-Hero.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/23614c9f-2f3f-4cc6-b891-e7c96b41ce43_01_Business-Expense-Cards-Hero.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/23614c9f-2f3f-4cc6-b891-e7c96b41ce43_01_Business-Expense-Cards-Hero.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null },
					predefined_signup_banner: {
						type: "signup_banner",
						document: {
							_previewable: "XymovhEAACYABewa",
							type: "signup_banner",
							data: {
								title: "Get started with Pleo",
								subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
								email_input_placeholder: "Your company email",
								email_input_error_text: "Please sign up with your company email",
								submit_text: "Get started",
								aria_label: "email",
								disclaimer_copy: { richText: [] },
								image: {
									alt: null,
									copyright: null,
									url: null,
									dimensions: null
								},
								redirect_link: {
									link_type: "Any",
									uid: null,
									type: null,
									lang: null,
									target: null,
									url: null
								},
								form_name: null,
								form_production: {
									formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
									consents: {
										type: "implicit_consent_to_process",
										communicationConsents: [{
											id: 5355469,
											required: false
										}]
									}
								},
								form_staging: {
									formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
									consents: {
										type: "explicit_consent_to_process",
										communicationConsents: [{
											id: 108196403,
											required: false
										}]
									}
								}
							}
						}
					},
					predefined_proof_point_badges: { document: { data: {
						proof_point_first: [{
							title: "Up to 0.75% cashback",
							subtitle: "T&Cs apply",
							icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/d66ae76f-7ded-4d70-90b7-a872c0368175_star-drawn.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 38,
									width: 38
								}
							}
						}],
						proof_point_second: [{
							title: "Bank-level security",
							subtitle: "FSA & PCI regulated",
							icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/dfad352e-ad1b-4c12-a52c-e1914befb5d3_padlock-drawn.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 43,
									width: 43
								}
							}
						}]
					} } }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyCustomers",
				primary: {
					title: "One spending solution, {{numberOfCustomers}}+ happy customers",
					predefined_logos: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Trusted by more than {{numberOfCustomers}} companies",
							spans: []
						}] },
						logos: [
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/b892536a-0265-45c4-8b84-4c9a2c3bb84a_soho%20house%20thickened-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 250
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/ef470c53-8f56-4448-b1e1-4080cf075bfc_Blinkist.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 250
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/729c0a9d-23d6-426a-9973-d67c024ec6e1_hello%20fresh%20logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 320,
									width: 666
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/71f2f2a3-9db8-4131-98ed-1c05f5dbf52a_lyst%20logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 217,
									width: 692
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/0a6becfd-44ed-4e7b-970f-be70e7a2dd51_Unity_black.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 403,
									width: 1156
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/e5083805-f42d-44a4-ba53-5aca09498078_voi_logo%201.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 52,
									width: 124
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/9aac3bd8-5ac4-49f6-92b0-2ab07ff55e66_Too%20Good%20To%20Go.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 60,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/23b1da9c-4e97-4151-a2cf-a3b6e1421780_LIONS-logo-Black%20(1).png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 277,
									width: 896
								}
							} }
						]
					} } }
				},
				items: []
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Need to buy something for work? Pleo it",
					inverse: true,
					background: "default",
					headline: "Employee expense cards",
					description: { richText: [{
						type: "paragraph",
						text: "Replace petty cash and shared credit cards with a Pleo employee business expense card. Trust your team without compromising on control with a Pleo card, offering individual spend limits, built-in controls, automated receipt capture and more. Virtual, physical or both – you decide who gets which card based on their needs.",
						spans: [{
							start: 242,
							end: 249,
							type: "hyperlink",
							data: {
								id: "YBFtXBAAACEARYvW",
								type: "slice_page",
								tags: [],
								lang: "en-gb",
								slug: "signupform",
								first_publication_date: "2021-02-02T12:15:28+0000",
								last_publication_date: "2023-10-25T17:02:43+0000",
								uid: "virtual-cards",
								link_type: "Document",
								isBroken: false
							}
						}]
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: null,
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/6fd400b2-bdc5-48c7-ba72-cf9e2e1d6026_02_Business-Expense-Cards-Need-to-buy-sth-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/6fd400b2-bdc5-48c7-ba72-cf9e2e1d6026_02_Business-Expense-Cards-Need-to-buy-sth-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/6fd400b2-bdc5-48c7-ba72-cf9e2e1d6026_02_Business-Expense-Cards-Need-to-buy-sth-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/6fd400b2-bdc5-48c7-ba72-cf9e2e1d6026_02_Business-Expense-Cards-Need-to-buy-sth-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/6fd400b2-bdc5-48c7-ba72-cf9e2e1d6026_02_Business-Expense-Cards-Need-to-buy-sth-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/6fd400b2-bdc5-48c7-ba72-cf9e2e1d6026_02_Business-Expense-Cards-Need-to-buy-sth-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Recurring payments? Pleo them",
					inverse: false,
					background: "default",
					headline: "New! Virtual Vendor cards",
					description: { richText: [{
						type: "paragraph",
						text: "Control your finances and eliminate nasty surprises with a Vendor card that lets you centralise and limit payments to one or a group of vendors of your choice. Easily adjust spending limits or change cardholders without cancelling business-critical expenses  like subscriptions, cloud computing or ads.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: null,
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/0cf66139-fac0-4e8d-92d6-3432160c2e84_03_Business-Expense-Cards-Recurring-payments-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/0cf66139-fac0-4e8d-92d6-3432160c2e84_03_Business-Expense-Cards-Recurring-payments-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/0cf66139-fac0-4e8d-92d6-3432160c2e84_03_Business-Expense-Cards-Recurring-payments-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/0cf66139-fac0-4e8d-92d6-3432160c2e84_03_Business-Expense-Cards-Recurring-payments-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/0cf66139-fac0-4e8d-92d6-3432160c2e84_03_Business-Expense-Cards-Recurring-payments-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/0cf66139-fac0-4e8d-92d6-3432160c2e84_03_Business-Expense-Cards-Recurring-payments-EN.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyMediaItemGrid",
				primary: {
					title: "Take the stress out of business spending with Pleo",
					layout: "three_columns",
					background: "muted"
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/b937505b-57e4-4575-b7b2-e63809f047e4_Dollars%20circular.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Up to 0.75% cashback",
						item_description: { richText: [{
							type: "paragraph",
							text: "Make money while spending. Every time you pay with a Pleo card, get money back.",
							spans: [{
								start: 0,
								end: 25,
								type: "hyperlink",
								data: {
									id: "YvSgpxAAACEA8F8l",
									type: "slice_page",
									tags: ["page"],
									lang: "en-gb",
									slug: "hero",
									first_publication_date: "2022-09-19T10:31:04+0000",
									last_publication_date: "2023-03-13T07:54:36+0000",
									uid: "cashback",
									link_type: "Document",
									isBroken: false
								}
							}]
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/d6729104-e004-4b6e-9529-b0218501cdd2_Limits.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Custom spend controls",
						item_description: { richText: [{
							type: "paragraph",
							text: "Set approval flows and spending limits per employee, purchase or vendor.",
							spans: [{
								start: 4,
								end: 38,
								type: "hyperlink",
								data: {
									id: "ZFTCsBAAACYA5WoD",
									type: "slice_page",
									tags: ["core_batch1"],
									lang: "en-gb",
									slug: "full-flexibility.-complete-control.",
									first_publication_date: "2023-05-05T09:07:47+0000",
									last_publication_date: "2023-05-17T10:18:24+0000",
									uid: "spend-controls",
									link_type: "Document",
									isBroken: false
								}
							}]
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/23a15028-d1b8-4f34-b8cb-0a02b37e9f64_Card_management.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Easy card management",
						item_description: { richText: [{
							type: "paragraph",
							text: "Create, freeze or cancel cards for team members in just a few clicks.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/3441db23-6b83-45c4-8d4c-2edfcb8e4132_Binoculars.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Real-time overview",
						item_description: { richText: [{
							type: "paragraph",
							text: "Get instant visibility of all company spend – from daily expenses to subscriptions.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/e83ca9a1-300f-43e6-bb30-8bec9920ee91_Globe.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Powered by Mastercard",
						item_description: { richText: [{
							type: "paragraph",
							text: "Use a Pleo card at more than 30 million merchants worldwide.",
							spans: []
						}] }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodySteps",
				primary: {
					title: null,
					description: { richText: [] },
					show_count: false,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_text: null
				},
				items: []
			},
			{
				__typename: "PrismicSlicePageDataBodySocialProof",
				primary: {
					title: null,
					inverse: false
				},
				items: [{
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null,
						gatsbyImageData: null
					},
					quote: null,
					full_name: null,
					person_byline: null,
					predefined_testimonial: { document: { data: {
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/f25c06f3-9cdc-4890-89e5-8ffb1747d8b6_Quote_Blinkist.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 1120,
								width: 1200
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/f25c06f3-9cdc-4890-89e5-8ffb1747d8b6_Quote_Blinkist.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1120",
										srcSet: "https://images.prismic.io/commercial-helios/f25c06f3-9cdc-4890-89e5-8ffb1747d8b6_Quote_Blinkist.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=672 720w,\nhttps://images.prismic.io/commercial-helios/f25c06f3-9cdc-4890-89e5-8ffb1747d8b6_Quote_Blinkist.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=877 940w,\nhttps://images.prismic.io/commercial-helios/f25c06f3-9cdc-4890-89e5-8ffb1747d8b6_Quote_Blinkist.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1008 1080w,\nhttps://images.prismic.io/commercial-helios/f25c06f3-9cdc-4890-89e5-8ffb1747d8b6_Quote_Blinkist.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1120 1200w",
										sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
									}
								},
								layout: "constrained",
								width: 1200,
								height: 1120
							}
						},
						quote: "Because employees can have their own company cards, they can pay for software subscriptions themselves quickly and easily.",
						attribution_name: "Faith Metobo",
						attribution_title: "Senior Finance Manager, Blinkist"
					} } }
				}, {
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null,
						gatsbyImageData: null
					},
					quote: null,
					full_name: null,
					person_byline: null,
					predefined_testimonial: { document: { data: {
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 2240,
								width: 2400
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240",
										srcSet: "https://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=672 720w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=877 940w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1008 1080w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1440&h=1344 1440w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240 2400w",
										sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
									}
								},
								layout: "constrained",
								width: 2400,
								height: 2240
							}
						},
						quote: "We used to spend around 10% of our time on credit card reconciliations a month, and thanks to Pleo this has been reduced to around 2%.",
						attribution_name: "Charlie Maynard",
						attribution_title: "Finance Manager, what3words"
					} } }
				}]
			},
			{
				__typename: "PrismicSlicePageDataBodyComparisonTable",
				primary: {
					section_heading: "Pleo cards – more powerful than business corporate cards",
					section_subheading: "Loved by finance teams and employees alike",
					column_1_heading: "Pleo cards",
					column_2_heading: "Credit cards"
				},
				items: [
					{
						heading: "Visibility",
						data_1: "See transactions in real-time – if something doesn’t look right, flag it immediately.",
						data_2: "See transactions in a monthly statement – making it hard to spot problems right away."
					},
					{
						heading: "Control",
						data_1: "Set individual spending limits for each card and easily adjust them if needed.",
						data_2: "The card balance is the same as the account balance – which means unlimited access to funds."
					},
					{
						heading: "People management",
						data_1: "Issue virtual or physical cards instantly. Freeze cards with a click of a button.",
						data_2: "Issuing a card requires a long application process with lots of paperwork."
					},
					{
						heading: "Support",
						data_1: "Proactive customer support, available via chat, email or phone.",
						data_2: "Long wait times for help, just when you need fast answers."
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyRatingsPlusHeadline",
				primary: {
					ratings_title: { richText: [] },
					ratings_lead_text: null,
					ratings_cta_text: null,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					predefined_ratings: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Highly rated in all the right places",
							spans: []
						}] },
						lead_text: null,
						cta_text: null,
						cta_link: {
							link_type: "Any",
							uid: null,
							type: null,
							lang: null,
							target: null,
							url: null
						},
						ratings: [
							{ rating: { document: { data: {
								logo: {
									alt: "G2 logo",
									copyright: "é",
									url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a49767c4-88c2-4b6f-ae3c-b236df9fbce6_G2_Logo_Red_RGB.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 150,
										width: 150
									}
								},
								rating_number: 4.8,
								link: "https://www.g2.com/products/pleo/reviews"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Capterra logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/ac82880a-40b6-43b9-975f-2f5d44310463_capterralogo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 345,
										width: 1500
									}
								},
								rating_number: 4.9,
								link: "https://www.capterra.co.uk/software/160720/pleo"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Xero Marketplace logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/4b26d78f-4a6c-485f-8260-6435a1299454_xero-connected.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 622,
										width: 1213
									}
								},
								rating_number: 5,
								link: "https://apps.xero.com/uk/app/pleo"
							} } } }
						]
					} } }
				},
				items: [{ rating: { document: null } }]
			},
			{
				__typename: "PrismicSlicePageDataBodyGetStarted",
				primary: {
					title: null,
					error_message: null,
					button_label: null,
					input_placeholder: null,
					form_subtitle: null,
					aria_label: null,
					form_production: null,
					form_staging: null,
					section_color: null,
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null
					},
					predefined_signup_banner: { document: {
						_previewable: "Y9fgvxAAACEAM-os",
						type: "signup_banner",
						data: {
							title: "Get your first 2 Pleo cards for free",
							subtitle: "Sign up for our Starter plan, get 2 Pleo cards (for free!) and see how it feels to automate your business expenses.",
							email_input_placeholder: "Your company email",
							email_input_error_text: "Please sign up with your company email",
							submit_text: "Get started",
							aria_label: "email",
							disclaimer_copy: { richText: [] },
							image: {
								alt: null,
								copyright: null,
								url: null,
								dimensions: null
							},
							redirect_link: {
								link_type: "Any",
								uid: null,
								type: null,
								lang: null,
								target: null,
								url: null
							},
							form_name: null,
							form_production: {
								formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
								consents: {
									type: "implicit_consent_to_process",
									communicationConsents: [{
										id: 5355469,
										required: false
									}]
								}
							},
							form_staging: {
								formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
								consents: {
									type: "explicit_consent_to_process",
									communicationConsents: [{
										id: 108196403,
										required: false
									}]
								}
							}
						}
					} }
				},
				items: []
			}
		],
		meta: {
			title: "Business expense cards | Employee expense cards",
			description: "Corporate expenses, business travel, per diem reimbursements. Pleo's smart company cards and spend management software handle it all.",
			openGraphImageUrl: "https://images.prismic.io/commercial-helios/4c1ff67e-cc95-4cd7-ad21-de4a2c538879_05_Business_Expense_Cards.jpg",
			canonicalLocation: "/us/business-expense-cards"
		}
	},
	{
		uid: "features",
		slices: [
			{
				__typename: "PrismicSlicePageDataBodyHero",
				primary: {
					section_html_id: null,
					title: "Take the stress out of business spending",
					inverse: false,
					is_oversized_image: false,
					lead_text: { richText: [{
						type: "paragraph",
						text: "Replace petty cash, shared company cards and manual expense reports with Europe’s #1 business spend solution. See how it feels to be in control of your spending. ",
						spans: []
					}] },
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/96a73359-878c-493b-847d-27886e85ad6c_Hero-features-page.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/96a73359-878c-493b-847d-27886e85ad6c_Hero-features-page.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/96a73359-878c-493b-847d-27886e85ad6c_Hero-features-page.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/96a73359-878c-493b-847d-27886e85ad6c_Hero-features-page.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/96a73359-878c-493b-847d-27886e85ad6c_Hero-features-page.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/96a73359-878c-493b-847d-27886e85ad6c_Hero-features-page.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null },
					predefined_signup_banner: {
						type: "signup_banner",
						document: {
							_previewable: "XymovhEAACYABewa",
							type: "signup_banner",
							data: {
								title: "Get started with Pleo",
								subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
								email_input_placeholder: "Your company email",
								email_input_error_text: "Please sign up with your company email",
								submit_text: "Get started",
								aria_label: "email",
								disclaimer_copy: { richText: [] },
								image: {
									alt: null,
									copyright: null,
									url: null,
									dimensions: null
								},
								redirect_link: {
									link_type: "Any",
									uid: null,
									type: null,
									lang: null,
									target: null,
									url: null
								},
								form_name: null,
								form_production: {
									formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
									consents: {
										type: "implicit_consent_to_process",
										communicationConsents: [{
											id: 5355469,
											required: false
										}]
									}
								},
								form_staging: {
									formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
									consents: {
										type: "explicit_consent_to_process",
										communicationConsents: [{
											id: 108196403,
											required: false
										}]
									}
								}
							}
						}
					},
					predefined_proof_point_badges: { document: { data: {
						proof_point_first: [{
							title: "Leading expenses tool in Europe",
							subtitle: "1480+ five star reviews",
							icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/d66ae76f-7ded-4d70-90b7-a872c0368175_star-drawn.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 38,
									width: 38
								}
							}
						}],
						proof_point_second: [{
							title: "Bank-level security",
							subtitle: "FSA & PCI regulated",
							icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/dfad352e-ad1b-4c12-a52c-e1914befb5d3_padlock-drawn.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 43,
									width: 43
								}
							}
						}]
					} } }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyCustomers",
				primary: {
					title: null,
					predefined_logos: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Trusted by more than {{numberOfCustomers}} companies",
							spans: []
						}] },
						logos: [
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/b892536a-0265-45c4-8b84-4c9a2c3bb84a_soho%20house%20thickened-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 250
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/ef470c53-8f56-4448-b1e1-4080cf075bfc_Blinkist.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 250
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/729c0a9d-23d6-426a-9973-d67c024ec6e1_hello%20fresh%20logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 320,
									width: 666
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/71f2f2a3-9db8-4131-98ed-1c05f5dbf52a_lyst%20logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 217,
									width: 692
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/0a6becfd-44ed-4e7b-970f-be70e7a2dd51_Unity_black.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 403,
									width: 1156
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/e5083805-f42d-44a4-ba53-5aca09498078_voi_logo%201.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 52,
									width: 124
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/9aac3bd8-5ac4-49f6-92b0-2ab07ff55e66_Too%20Good%20To%20Go.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 60,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/23b1da9c-4e97-4151-a2cf-a3b6e1421780_LIONS-logo-Black%20(1).png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 277,
									width: 896
								}
							} }
						]
					} } }
				},
				items: []
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureGrid",
				primary: {
					title: "How Pleo works",
					background: "default"
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/fc72b4f1-6717-4e35-b65e-a18a527ce778_features-teams-spend-with-ease.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 975,
								width: 1362
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/fc72b4f1-6717-4e35-b65e-a18a527ce778_features-teams-spend-with-ease.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1362&h=975",
										srcSet: "https://images.prismic.io/commercial-helios/fc72b4f1-6717-4e35-b65e-a18a527ce778_features-teams-spend-with-ease.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=515 720w,\nhttps://images.prismic.io/commercial-helios/fc72b4f1-6717-4e35-b65e-a18a527ce778_features-teams-spend-with-ease.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=673 940w,\nhttps://images.prismic.io/commercial-helios/fc72b4f1-6717-4e35-b65e-a18a527ce778_features-teams-spend-with-ease.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=773 1080w,\nhttps://images.prismic.io/commercial-helios/fc72b4f1-6717-4e35-b65e-a18a527ce778_features-teams-spend-with-ease.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1362&h=975 1362w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 1362,
								height: 975
							}
						},
						feature_title: "Teams spend with ease",
						feature_description: { richText: [{
							type: "paragraph",
							text: "Employees use their own Pleo company cards for their expenses.  Receipts are then captured in the Pleo app, making manual expense reports a thing of the past. ",
							spans: []
						}] },
						predefined_feature: { document: null }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/844a3bfe-a889-45de-aae4-8162798cf21c_features-you-hold-the-purse-strings.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 975,
								width: 1362
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/844a3bfe-a889-45de-aae4-8162798cf21c_features-you-hold-the-purse-strings.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1362&h=975",
										srcSet: "https://images.prismic.io/commercial-helios/844a3bfe-a889-45de-aae4-8162798cf21c_features-you-hold-the-purse-strings.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=515 720w,\nhttps://images.prismic.io/commercial-helios/844a3bfe-a889-45de-aae4-8162798cf21c_features-you-hold-the-purse-strings.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=673 940w,\nhttps://images.prismic.io/commercial-helios/844a3bfe-a889-45de-aae4-8162798cf21c_features-you-hold-the-purse-strings.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=773 1080w,\nhttps://images.prismic.io/commercial-helios/844a3bfe-a889-45de-aae4-8162798cf21c_features-you-hold-the-purse-strings.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1362&h=975 1362w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 1362,
								height: 975
							}
						},
						feature_title: "You hold the purse strings",
						feature_description: { richText: [{
							type: "paragraph",
							text: "Set adjustable card limits, create expense review thresholds and get real-time spending analytics. No more overspending, lost receipts or missing expense details.  ",
							spans: []
						}] },
						predefined_feature: { document: null }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/87a94c59-04e1-4a3e-837d-9503ee1d335f_features-spending-but-centralised.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 975,
								width: 1362
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/87a94c59-04e1-4a3e-837d-9503ee1d335f_features-spending-but-centralised.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1362&h=975",
										srcSet: "https://images.prismic.io/commercial-helios/87a94c59-04e1-4a3e-837d-9503ee1d335f_features-spending-but-centralised.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=515 720w,\nhttps://images.prismic.io/commercial-helios/87a94c59-04e1-4a3e-837d-9503ee1d335f_features-spending-but-centralised.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=673 940w,\nhttps://images.prismic.io/commercial-helios/87a94c59-04e1-4a3e-837d-9503ee1d335f_features-spending-but-centralised.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=773 1080w,\nhttps://images.prismic.io/commercial-helios/87a94c59-04e1-4a3e-837d-9503ee1d335f_features-spending-but-centralised.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1362&h=975 1362w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 1362,
								height: 975
							}
						},
						feature_title: "Spending, but centralised",
						feature_description: { richText: [{
							type: "paragraph",
							text: "Pleo is more than just a company card. You can also manage your reimbursements, invoices and mileage expenses, as well as connect to your main accounting system. ",
							spans: []
						}] },
						predefined_feature: { document: null }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodySocialProof",
				primary: {
					title: null,
					inverse: false
				},
				items: [{
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null,
						gatsbyImageData: null
					},
					quote: null,
					full_name: null,
					person_byline: null,
					predefined_testimonial: { document: { data: {
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 2240,
								width: 2400
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240",
										srcSet: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=672 720w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=877 940w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1008 1080w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1440&h=1344 1440w,\nhttps://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240 2400w",
										sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
									}
								},
								layout: "constrained",
								width: 2400,
								height: 2240
							}
						},
						quote: "We used to spend around 10% of our time on credit card reconciliations a month, and thanks to Pleo this has been reduced to around 2%.",
						attribution_name: "Charlie Maynard",
						attribution_title: "Finance Manager, what3words"
					} } }
				}]
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Need something for work? Pleo it",
					inverse: false,
					background: "grey",
					headline: "Business expense cards",
					description: { richText: [{
						type: "paragraph",
						text: "Pleo company cards make expenses easier for employees and finance teams alike. Everyone gets their own card to buy what they need for work. Everything from flights to software subscriptions – whatever’s within policy. The best part? You get to save as you spend with up to 0.75% cashback, too.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: "Learn more",
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Document",
						uid: "business-expense-cards",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/business-expense-cards"
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/ff9b0220-7376-45be-aba4-15a5ffa5f4ba_features-exports-business-cards-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/ff9b0220-7376-45be-aba4-15a5ffa5f4ba_features-exports-business-cards-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/ff9b0220-7376-45be-aba4-15a5ffa5f4ba_features-exports-business-cards-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/ff9b0220-7376-45be-aba4-15a5ffa5f4ba_features-exports-business-cards-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/ff9b0220-7376-45be-aba4-15a5ffa5f4ba_features-exports-business-cards-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/ff9b0220-7376-45be-aba4-15a5ffa5f4ba_features-exports-business-cards-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyCardGrid",
				primary: {
					blockTitle: { richText: [{
						type: "paragraph",
						text: "",
						spans: []
					}] },
					subtitle: null,
					show_more_text: null,
					initial_cards_shown: "all",
					initial_cards_shown_on_mobile: null,
					initial_cards_shown_on_desktop: null,
					card_cta_text: "Learn more",
					show_filter: false,
					layout: null
				},
				items: [{
					image: {
						alt: null,
						copyright: null,
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/930b9fa4-9f9a-482d-8ce7-f7ca9cae1eee_Cashback-Feature-Block.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 150,
							width: 209
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://commercial-helios.cdn.prismic.io/commercial-helios/930b9fa4-9f9a-482d-8ce7-f7ca9cae1eee_Cashback-Feature-Block.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=209&h=150",
									srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/930b9fa4-9f9a-482d-8ce7-f7ca9cae1eee_Cashback-Feature-Block.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=209&h=150 209w",
									sizes: "(max-width: 575px) calc(100vw - 2 * 24px - 2 * 20px), (max-width: 767px) calc(50vw - 1.5 * 24px - 2 * 20px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
								}
							},
							layout: "constrained",
							width: 209,
							height: 150
						}
					},
					title: "Cashback",
					body: "Earn up to 0.75% cashback every time you spend when you sign up for our annual plans.",
					cta_link: {
						link_type: "Document",
						uid: "cashback",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/cashback"
					},
					filterKeywords: null,
					tag_text: null,
					tag_color: "blue"
				}, {
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/e8893098-55d0-49d1-b39b-441536b10fe9_features-virtual-cards.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 340,
							width: 450
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/e8893098-55d0-49d1-b39b-441536b10fe9_features-virtual-cards.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=450&h=340",
									srcSet: "https://images.prismic.io/commercial-helios/e8893098-55d0-49d1-b39b-441536b10fe9_features-virtual-cards.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=450&h=340 450w",
									sizes: "(max-width: 575px) calc(100vw - 2 * 24px - 2 * 20px), (max-width: 767px) calc(50vw - 1.5 * 24px - 2 * 20px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
								}
							},
							layout: "constrained",
							width: 450,
							height: 340
						}
					},
					title: "Virtual cards",
					body: "These are issued in seconds, so your team members can start spending straight away.",
					cta_link: {
						link_type: "Document",
						uid: "virtual-cards",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/virtual-cards"
					},
					filterKeywords: null,
					tag_text: null,
					tag_color: "blue"
				}]
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Where expenses meet speed and automation",
					inverse: false,
					background: "default",
					headline: "Expense management",
					description: { richText: [{
						type: "paragraph",
						text: "Every time your team buys something using Pleo, they'll be asked to add the receipt in our app.  Our Fetch feature makes this easy by automatically matching the expense with the online purchase receipt. This expense data can then be synced to your accounting tools of choice, simplifying your workflows and saving your finance team valuable time. ",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: "Learn more",
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Document",
						uid: "howitworks",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/howitworks"
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/6b55387d-c1a7-4b0d-af6f-6b15b3891bc6_features-exports-expense-management-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/6b55387d-c1a7-4b0d-af6f-6b15b3891bc6_features-exports-expense-management-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/6b55387d-c1a7-4b0d-af6f-6b15b3891bc6_features-exports-expense-management-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/6b55387d-c1a7-4b0d-af6f-6b15b3891bc6_features-exports-expense-management-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/6b55387d-c1a7-4b0d-af6f-6b15b3891bc6_features-exports-expense-management-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/6b55387d-c1a7-4b0d-af6f-6b15b3891bc6_features-exports-expense-management-ENG-GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "The easiest way to handle out-of-pocket expenses",
					inverse: true,
					background: "default",
					headline: "Reimbursements",
					description: { richText: [{
						type: "paragraph",
						text: "Out-of-pocket doesn’t have to mean out-of-control. With Pleo, all self-funded expenses - from mileage to client lunches - are submitted, approved and processed within company policy. Quick, compliant, simple. ",
						spans: [{
							start: 94,
							end: 101,
							type: "hyperlink",
							data: {
								id: "X_YF9REAACEALVy7",
								type: "slice_page",
								tags: ["core_batch1"],
								lang: "en-gb",
								slug: "signupform",
								first_publication_date: "2021-01-13T18:49:50+0000",
								last_publication_date: "2023-10-25T17:02:43+0000",
								uid: "for-transport",
								link_type: "Document",
								isBroken: false
							}
						}]
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: "Learn more",
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Document",
						uid: "reimbursements",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/reimbursements"
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/0460edc7-312e-4455-815a-7e230808c40e_Reimbursements-pop-up-plus-employee-view.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/0460edc7-312e-4455-815a-7e230808c40e_Reimbursements-pop-up-plus-employee-view.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/0460edc7-312e-4455-815a-7e230808c40e_Reimbursements-pop-up-plus-employee-view.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/0460edc7-312e-4455-815a-7e230808c40e_Reimbursements-pop-up-plus-employee-view.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/0460edc7-312e-4455-815a-7e230808c40e_Reimbursements-pop-up-plus-employee-view.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/0460edc7-312e-4455-815a-7e230808c40e_Reimbursements-pop-up-plus-employee-view.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Invoice processing? It’s in the bag",
					inverse: false,
					background: "default",
					headline: "Invoices",
					description: { richText: [{
						type: "paragraph",
						text: "Pleo transforms your invoice management by simplifying the process from start to finish. Get full visibility of your accounts payable, avoid manual data entry errors with invoice OCR and avoid late payment fees by scheduling and automating your payments to go out on time.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: "Learn more",
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Document",
						uid: "invoices",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/invoices"
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/8c8a0dd8-9f31-4c89-866f-71a51ccb30d8_invoices%20EN%20GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/8c8a0dd8-9f31-4c89-866f-71a51ccb30d8_invoices%20EN%20GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/8c8a0dd8-9f31-4c89-866f-71a51ccb30d8_invoices%20EN%20GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/8c8a0dd8-9f31-4c89-866f-71a51ccb30d8_invoices%20EN%20GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/8c8a0dd8-9f31-4c89-866f-71a51ccb30d8_invoices%20EN%20GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/8c8a0dd8-9f31-4c89-866f-71a51ccb30d8_invoices%20EN%20GBP.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyCardGrid",
				primary: {
					blockTitle: { richText: [{
						type: "paragraph",
						text: "Simplify your spending in more ways than one",
						spans: []
					}] },
					subtitle: null,
					show_more_text: null,
					initial_cards_shown: "4",
					initial_cards_shown_on_mobile: null,
					initial_cards_shown_on_desktop: null,
					card_cta_text: "Learn more",
					show_filter: false,
					layout: null
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/32492ee2-f964-448c-8403-11edd344d71d_features-mileage.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 643,
								width: 900
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/32492ee2-f964-448c-8403-11edd344d71d_features-mileage.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=900&h=643",
										srcSet: "https://images.prismic.io/commercial-helios/32492ee2-f964-448c-8403-11edd344d71d_features-mileage.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=514 720w,\nhttps://images.prismic.io/commercial-helios/32492ee2-f964-448c-8403-11edd344d71d_features-mileage.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=900&h=643 900w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px - 2 * 20px), (max-width: 767px) calc(50vw - 1.5 * 24px - 2 * 20px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 900,
								height: 643
							}
						},
						title: "Mileage",
						body: "Simply tell our app where a journey started and ended and we’ll work out what’s owed for fuel.",
						cta_link: {
							link_type: "Document",
							uid: "for-transport",
							type: "slice_page",
							lang: "en-gb",
							target: null,
							url: "/en/for-transport"
						},
						filterKeywords: null,
						tag_text: null,
						tag_color: "blue"
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/5b168b4f-2892-495a-a838-8dc6f332fd3e_expense%20management_for%20big%20businesses-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 210
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://commercial-helios.cdn.prismic.io/commercial-helios/5b168b4f-2892-495a-a838-8dc6f332fd3e_expense%20management_for%20big%20businesses-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150",
										srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/5b168b4f-2892-495a-a838-8dc6f332fd3e_expense%20management_for%20big%20businesses-smaller-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=210&h=150 210w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px - 2 * 20px), (max-width: 767px) calc(50vw - 1.5 * 24px - 2 * 20px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 210,
								height: 150
							}
						},
						title: "Multi-entity management",
						body: "Empower your finance team to manage all spending through one account, no matter where you operate or how many offices you have.",
						cta_link: {
							link_type: "Document",
							uid: "multi-entity-businesses",
							type: "slice_page",
							lang: "en-gb",
							target: null,
							url: "/en/multi-entity-businesses"
						},
						filterKeywords: null,
						tag_text: null,
						tag_color: "blue"
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/33115b20-2b5f-44de-807d-0293bb777e89_features-budgets.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 643,
								width: 900
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/33115b20-2b5f-44de-807d-0293bb777e89_features-budgets.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=900&h=643",
										srcSet: "https://images.prismic.io/commercial-helios/33115b20-2b5f-44de-807d-0293bb777e89_features-budgets.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=514 720w,\nhttps://images.prismic.io/commercial-helios/33115b20-2b5f-44de-807d-0293bb777e89_features-budgets.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=900&h=643 900w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px - 2 * 20px), (max-width: 767px) calc(50vw - 1.5 * 24px - 2 * 20px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 900,
								height: 643
							}
						},
						title: "Spend controls",
						body: "Feel confident that your budget won't budge with Pleo’s personalised spend limits, multi-step approvals and more.",
						cta_link: {
							link_type: "Document",
							uid: "spend-controls",
							type: "slice_page",
							lang: "en-gb",
							target: null,
							url: "/en/spend-controls"
						},
						filterKeywords: null,
						tag_text: null,
						tag_color: "blue"
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/a1d24aa4-63b2-4d8d-a5b4-2961a706a7c8_features-fetch.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 643,
								width: 900
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/a1d24aa4-63b2-4d8d-a5b4-2961a706a7c8_features-fetch.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=900&h=643",
										srcSet: "https://images.prismic.io/commercial-helios/a1d24aa4-63b2-4d8d-a5b4-2961a706a7c8_features-fetch.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=514 720w,\nhttps://images.prismic.io/commercial-helios/a1d24aa4-63b2-4d8d-a5b4-2961a706a7c8_features-fetch.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=900&h=643 900w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px - 2 * 20px), (max-width: 767px) calc(50vw - 1.5 * 24px - 2 * 20px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 900,
								height: 643
							}
						},
						title: "Email receipt finder",
						body: "Leave it to Pleo to automatically fetch receipts from your Gmail, Outlook or Microsoft 365 inbox and match them with your expenses.",
						cta_link: {
							link_type: "Document",
							uid: null,
							type: "fetch_page",
							lang: "en-gb",
							target: null,
							url: "/en/fetch"
						},
						filterKeywords: null,
						tag_text: null,
						tag_color: "blue"
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Keep your cash flow… well, flowing",
					inverse: true,
					background: "default",
					headline: "Overdrafts",
					description: { richText: [{
						type: "paragraph",
						text: "Managing cash flow for your business can be stressful. Keep essential outgoings running seamlessly and pay your suppliers on time with a Pleo Overdraft. And the best bit? It’s completely interest-free when you repay on time.\n \nRun all of your high-value transactions and recurring spend - from SaaS and marketing tools to office rent - through one platform, safe in the knowledge that we’ve got you covered if your balance runs low. With an Overdraft, you can forget about a lack of funds leading to declined transactions which disrupt your day-to-day. Flow money, no problems.\n \n *Only available in certain markets. Eligibility approved on a per-customer basis.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: null,
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/c72419e9-d953-4c2e-b78f-7064494026af_01_Overdraft-no-interest-by-B-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/c72419e9-d953-4c2e-b78f-7064494026af_01_Overdraft-no-interest-by-B-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/c72419e9-d953-4c2e-b78f-7064494026af_01_Overdraft-no-interest-by-B-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/c72419e9-d953-4c2e-b78f-7064494026af_01_Overdraft-no-interest-by-B-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/c72419e9-d953-4c2e-b78f-7064494026af_01_Overdraft-no-interest-by-B-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/c72419e9-d953-4c2e-b78f-7064494026af_01_Overdraft-no-interest-by-B-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Connect Pleo with your favorite tools",
					inverse: false,
					background: "default",
					headline: null,
					description: { richText: [{
						type: "paragraph",
						text: "Easily export your expense data into the systems your accountants use every day. Pleo integrates with most accounting systems, including Xero and Quickbooks, so you can wave goodbye to lengthy reconciliation making end-of-month a nightmare.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: "View integrations",
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Document",
						uid: "integrations",
						type: "slice_page",
						lang: "en-gb",
						target: null,
						url: "/en/integrations"
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1866,
							width: 2332
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2332&h=1866",
									srcSet: "https://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=576 720w,\nhttps://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=752 940w,\nhttps://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=864 1080w,\nhttps://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1440&h=1152 1440w,\nhttps://images.prismic.io/commercial-helios/84c664d0-4482-4fb8-939f-5feb871f9f94_UK%20integrations%20hero%20travel%20perk.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2332&h=1866 2332w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 2332,
							height: 1865.9999999999998
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyContentPlusBlocks",
				primary: {
					background: "muted",
					plainTitle: "Solve your spending chaos",
					text_under_title: { richText: [{
						type: "paragraph",
						text: "Pleo helps to transform spending for companies (and teams) of all sizes, bringing you the control and peace of mind you crave.",
						spans: []
					}] }
				},
				items: [
					{
						block_image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/bd07d588-c2e1-446c-9f50-9c4d1cfd4448_CFO%20FDs.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 80,
								width: 80
							}
						},
						block_title: "For CFOs and FDs",
						block_content: { richText: [{
							type: "paragraph",
							text: "Spend more time scaling your business and less time approving expenses and filling in manual reports.",
							spans: []
						}] }
					},
					{
						block_image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/69c5409e-3451-41c2-a8f7-afc0002dec3a_finance%20mgrs.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 80,
								width: 80
							}
						},
						block_title: "For finance managers and accountants",
						block_content: { richText: [{
							type: "paragraph",
							text: "Save up to 138 hours each year with Pleo’s automated expense reports and seamless accounting integrations.",
							spans: []
						}] }
					},
					{
						block_image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/270b87c5-2a30-4feb-a570-fa852f029d3f_founders.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 80,
								width: 80
							}
						},
						block_title: "For founders and CEOs",
						block_content: { richText: [{
							type: "paragraph",
							text: "Make smarter, future-proof financial decisions with a real-time overview of what your employees are spending.",
							spans: []
						}] }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyMediaItemGrid",
				primary: {
					title: "The spending solution you can trust",
					layout: "two_columns",
					background: "default"
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/4aa048e9-6101-4203-bd5b-40dc07f2971b_PSD2.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 60,
								width: 100
							}
						},
						item_title: "Payment Service Directive 2 (PSD2)",
						item_description: { richText: [{
							type: "paragraph",
							text: "This allows us to feed into our Risk Engine and sets a Strong Customer Authentication to add an extra layer of security on all payments and user authentication.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a57ee458-6879-4c96-84d8-8e8b1edc89b7_mastercard.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 60,
								width: 100
							}
						},
						item_title: "Powered by Mastercard",
						item_description: { richText: [{
							type: "paragraph",
							text: "Pleo's cards are issued by Mastercard and can be used at more than 30 million merchants worldwide.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/88f5b550-98ec-4354-9686-29c6025180be_pci%20compliant.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 60,
								width: 100
							}
						},
						item_title: "PCI DSS Certificate",
						item_description: { richText: [{
							type: "paragraph",
							text: "We're certified with the Payment Card Industry Data Security Standard. This rigorous benchmark ensures we offer a safe and secure environment to protect your transaction data.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/f24d112a-d44d-40e9-836a-ad90142fae4f_pleo%20financial%20institution.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 60,
								width: 100
							}
						},
						item_title: "Financial Services A/S",
						item_description: { richText: [{
							type: "paragraph",
							text: "We are one of the few spending solutions that have our own licensed entity in the EEA, while in the UK we partner with B4B Payments. This means we can enforce our own compliance and fraud regulations respectively.",
							spans: []
						}] }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyRatingsPlusHeadline",
				primary: {
					ratings_title: { richText: [] },
					ratings_lead_text: null,
					ratings_cta_text: null,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					predefined_ratings: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Highly rated in all the right places",
							spans: []
						}] },
						lead_text: null,
						cta_text: null,
						cta_link: {
							link_type: "Any",
							uid: null,
							type: null,
							lang: null,
							target: null,
							url: null
						},
						ratings: [
							{ rating: { document: { data: {
								logo: {
									alt: "G2 logo",
									copyright: "é",
									url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a49767c4-88c2-4b6f-ae3c-b236df9fbce6_G2_Logo_Red_RGB.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 150,
										width: 150
									}
								},
								rating_number: 4.8,
								link: "https://www.g2.com/products/pleo/reviews"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Capterra logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/ac82880a-40b6-43b9-975f-2f5d44310463_capterralogo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 345,
										width: 1500
									}
								},
								rating_number: 4.9,
								link: "https://www.capterra.co.uk/software/160720/pleo"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Xero Marketplace logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/4b26d78f-4a6c-485f-8260-6435a1299454_xero-connected.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 622,
										width: 1213
									}
								},
								rating_number: 5,
								link: "https://apps.xero.com/uk/app/pleo"
							} } } }
						]
					} } }
				},
				items: [{ rating: { document: null } }]
			},
			{
				__typename: "PrismicSlicePageDataBodyGetStarted",
				primary: {
					title: null,
					error_message: null,
					button_label: null,
					input_placeholder: null,
					form_subtitle: null,
					aria_label: null,
					form_production: null,
					form_staging: null,
					section_color: null,
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null
					},
					predefined_signup_banner: { document: {
						_previewable: "XymovhEAACYABewa",
						type: "signup_banner",
						data: {
							title: "Get started with Pleo",
							subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
							email_input_placeholder: "Your company email",
							email_input_error_text: "Please sign up with your company email",
							submit_text: "Get started",
							aria_label: "email",
							disclaimer_copy: { richText: [] },
							image: {
								alt: null,
								copyright: null,
								url: null,
								dimensions: null
							},
							redirect_link: {
								link_type: "Any",
								uid: null,
								type: null,
								lang: null,
								target: null,
								url: null
							},
							form_name: null,
							form_production: {
								formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
								consents: {
									type: "implicit_consent_to_process",
									communicationConsents: [{
										id: 5355469,
										required: false
									}]
								}
							},
							form_staging: {
								formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
								consents: {
									type: "explicit_consent_to_process",
									communicationConsents: [{
										id: 108196403,
										required: false
									}]
								}
							}
						}
					} }
				},
				items: []
			}
		],
		meta: {
			title: "How Pleo transforms your business spending",
			description: "From bills to mileage and reimbursements, these are the Pleo features that can change how your company manages its money",
			openGraphImageUrl: "https://images.prismic.io/commercial-helios/2f6edcee-fe6e-4165-b418-6742655d5775_01_Metadata_image_features.jpg",
			canonicalLocation: "/us/features"
		}
	},
	{
		uid: "for-agencies",
		slices: [
			{
				__typename: "PrismicSlicePageDataBodyHero",
				primary: {
					section_html_id: null,
					title: "Business spending for forward-thinking teams.",
					inverse: false,
					is_oversized_image: false,
					lead_text: { richText: [{
						type: "paragraph",
						text: "Pleo empowers your agency team to buy what they need for work. Move beyond time-wasting admin and grow your business.",
						spans: []
					}] },
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/4fbf9e5d-ddce-4c83-b0a4-293b47cda9e7_performance_agency.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/4fbf9e5d-ddce-4c83-b0a4-293b47cda9e7_performance_agency.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/4fbf9e5d-ddce-4c83-b0a4-293b47cda9e7_performance_agency.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/4fbf9e5d-ddce-4c83-b0a4-293b47cda9e7_performance_agency.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/4fbf9e5d-ddce-4c83-b0a4-293b47cda9e7_performance_agency.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/4fbf9e5d-ddce-4c83-b0a4-293b47cda9e7_performance_agency.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null },
					predefined_signup_banner: {
						type: "signup_banner",
						document: {
							_previewable: "XymovhEAACYABewa",
							type: "signup_banner",
							data: {
								title: "Get started with Pleo",
								subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
								email_input_placeholder: "Your company email",
								email_input_error_text: "Please sign up with your company email",
								submit_text: "Get started",
								aria_label: "email",
								disclaimer_copy: { richText: [] },
								image: {
									alt: null,
									copyright: null,
									url: null,
									dimensions: null
								},
								redirect_link: {
									link_type: "Any",
									uid: null,
									type: null,
									lang: null,
									target: null,
									url: null
								},
								form_name: null,
								form_production: {
									formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
									consents: {
										type: "implicit_consent_to_process",
										communicationConsents: [{
											id: 5355469,
											required: false
										}]
									}
								},
								form_staging: {
									formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
									consents: {
										type: "explicit_consent_to_process",
										communicationConsents: [{
											id: 108196403,
											required: false
										}]
									}
								}
							}
						}
					},
					predefined_proof_point_badges: { document: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyCustomers",
				primary: {
					title: null,
					predefined_logos: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "One spending solution, thousands of happy companies",
							spans: []
						}] },
						logos: [
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/e669c382-c6cb-4d2e-98d3-0f44d5360ccf_Byron.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 60,
									width: 78
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/1ff81091-aa12-4dbd-95c2-715de0e4b3d0_Flux%201.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 65,
									width: 65
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/1579b7c6-2d61-470f-8fd0-e655d7fd2825_lyst.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 163,
									width: 300
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/c84c205a-2203-4e50-b37d-aeceaf311772_idc-logo.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 366,
									width: 1428
								}
							} }
						]
					} } }
				},
				items: [{ logo: {
					alt: null,
					copyright: null,
					url: null,
					dimensions: null
				} }]
			},
			{
				__typename: "PrismicSlicePageDataBodyContentPlusBlocks",
				primary: {
					background: "default",
					plainTitle: "A solution that’s built for agencies",
					text_under_title: { richText: [] }
				},
				items: [
					{
						block_image: {
							alt: null,
							copyright: null,
							url: null,
							dimensions: null
						},
						block_title: "Real-time overview",
						block_content: { richText: [{
							type: "paragraph",
							text: "Pleo tracks all of your team’s spending as it happens. Centralise your costs and see where your money is going.",
							spans: []
						}] }
					},
					{
						block_image: {
							alt: null,
							copyright: null,
							url: null,
							dimensions: null
						},
						block_title: "Power to your people",
						block_content: { richText: [{
							type: "paragraph",
							text: "You hire good people. Set them free from expense reports, mountains of receipts and sharing company cards.",
							spans: []
						}] }
					},
					{
						block_image: {
							alt: null,
							copyright: null,
							url: null,
							dimensions: null
						},
						block_title: "Pay your way with virtual cards",
						block_content: { richText: [{
							type: "paragraph",
							text: "Managing a scattered team isn’t easy. Our virtual cards mean you can buy what you need for work, wherever you’re working from.",
							spans: []
						}] }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Manage your software subscriptions",
					inverse: true,
					background: "default",
					headline: null,
					description: { richText: [{
						type: "paragraph",
						text: "Use Pleo to pay for the tools and services that your business relies on. See what everyone is signing up for – and avoid paying for subscriptions nobody uses.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: null,
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/bdb2299f-0944-4008-8353-28052e159d1a_marketing-ads-2.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1130,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/bdb2299f-0944-4008-8353-28052e159d1a_marketing-ads-2.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1130",
									srcSet: "https://images.prismic.io/commercial-helios/bdb2299f-0944-4008-8353-28052e159d1a_marketing-ads-2.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=678 720w,\nhttps://images.prismic.io/commercial-helios/bdb2299f-0944-4008-8353-28052e159d1a_marketing-ads-2.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=885 940w,\nhttps://images.prismic.io/commercial-helios/bdb2299f-0944-4008-8353-28052e159d1a_marketing-ads-2.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1017 1080w,\nhttps://images.prismic.io/commercial-helios/bdb2299f-0944-4008-8353-28052e159d1a_marketing-ads-2.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1130 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1130
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureGrid",
				primary: {
					title: "How it works",
					background: "default"
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://prismic-io.s3.amazonaws.com/commercial-helios/2caec26e-eaad-4a4c-b38d-2c441e8c270e_image-1.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 230,
								width: 374
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://prismic-io.s3.amazonaws.com/commercial-helios/2caec26e-eaad-4a4c-b38d-2c441e8c270e_image-1.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=374&h=230",
										srcSet: "https://prismic-io.s3.amazonaws.com/commercial-helios/2caec26e-eaad-4a4c-b38d-2c441e8c270e_image-1.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=374&h=230 374w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 374,
								height: 230
							}
						},
						feature_title: "Use your Pleo card to pay for something and you'll get an instant notification",
						feature_description: { richText: [] },
						predefined_feature: { document: null }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://prismic-io.s3.amazonaws.com/commercial-helios/6e2057e9-1cd7-4708-9895-1d0bd2224ac7_image-2.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 230,
								width: 374
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://prismic-io.s3.amazonaws.com/commercial-helios/6e2057e9-1cd7-4708-9895-1d0bd2224ac7_image-2.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=374&h=230",
										srcSet: "https://prismic-io.s3.amazonaws.com/commercial-helios/6e2057e9-1cd7-4708-9895-1d0bd2224ac7_image-2.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=374&h=230 374w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 374,
								height: 230
							}
						},
						feature_title: "Snap your receipt and add any important details to the Pleo app",
						feature_description: { richText: [] },
						predefined_feature: { document: null }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://prismic-io.s3.amazonaws.com/commercial-helios/4309d5dc-d6d3-4a30-b664-ccd62ee00185_image-3.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 230,
								width: 374
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://prismic-io.s3.amazonaws.com/commercial-helios/4309d5dc-d6d3-4a30-b664-ccd62ee00185_image-3.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=374&h=230",
										srcSet: "https://prismic-io.s3.amazonaws.com/commercial-helios/4309d5dc-d6d3-4a30-b664-ccd62ee00185_image-3.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=374&h=230 374w",
										sizes: "(max-width: 575px) calc(100vw - 2 * 24px), (max-width: 767px) calc(50vw - 1.5 * 24px), (max-width: 991px) calc(33.33vw - 1.5 * 24px - 2 * 20px), (max-width: 1439px) calc(25vw - 1.5 * 40px - 2 * 20px), 255px"
									}
								},
								layout: "constrained",
								width: 374,
								height: 230
							}
						},
						feature_title: "Thats it! No more reimbursements or tedious expense reports",
						feature_description: { richText: [] },
						predefined_feature: { document: null }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodySocialProof",
				primary: {
					title: null,
					inverse: false
				},
				items: [{
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/104f0600-3c69-4ce6-9a6f-aa32e2e45086_Trickle.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1166,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/104f0600-3c69-4ce6-9a6f-aa32e2e45086_Trickle.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1166",
									srcSet: "https://images.prismic.io/commercial-helios/104f0600-3c69-4ce6-9a6f-aa32e2e45086_Trickle.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=700 720w,\nhttps://images.prismic.io/commercial-helios/104f0600-3c69-4ce6-9a6f-aa32e2e45086_Trickle.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=913 940w,\nhttps://images.prismic.io/commercial-helios/104f0600-3c69-4ce6-9a6f-aa32e2e45086_Trickle.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1049 1080w,\nhttps://images.prismic.io/commercial-helios/104f0600-3c69-4ce6-9a6f-aa32e2e45086_Trickle.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1166 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1166
						}
					},
					quote: "Borrowing the company credit card feels a bit like asking your parents for money to go to the movies when you were 12.",
					full_name: "Ludvig Olsson",
					person_byline: "CEO & Co-Founder, Trickle",
					predefined_testimonial: { document: null }
				}]
			},
			{
				__typename: "PrismicSlicePageDataBodyCustomersLogosPlusHeadline",
				primary: {
					predefined_logos: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Trusted by more than {{numberOfCustomers}}+ companies",
							spans: [{
								start: 20,
								end: 43,
								type: "strong"
							}]
						}] },
						logos: [
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/c2a10a18-c7ad-48d3-9925-2810aec1b9b6_The%20tab.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 36,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/453bcb34-351e-405f-8e45-7dada18de75a_Drover.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 18,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/81c20a4c-feb4-4bdf-a30b-7b7dbe24adfb_Syft.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 33,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/e6a609c9-7054-4100-b178-772632c9923c_Charlie.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 30,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/8b1012bb-6c6d-4ac5-a0e5-d8b9f30e5b20_Paddle.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 38,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/e0e5c33b-b309-48eb-95ed-6ff0cec64fa0_Planday.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 21,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://prismic-io.s3.amazonaws.com/commercial-helios/29671eaa-1bad-462d-b7f8-7abe6976eaa1_Thread.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 21,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/c84c205a-2203-4e50-b37d-aeceaf311772_idc-logo.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 366,
									width: 1428
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/b78fec30-fa8e-4538-acd4-e5dc08616fa2_LYST.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 368,
									width: 1170
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/3b709e58-6a4a-471e-b2fe-a61501d790c7_Northvolt.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 60,
									width: 100
								}
							} }
						]
					} } },
					customer_logos_title: { richText: [] }
				},
				items: [{ icon: {
					alt: null,
					copyright: null,
					url: null,
					dimensions: null
				} }]
			},
			{
				__typename: "PrismicSlicePageDataBodyRatingsPlusHeadline",
				primary: {
					ratings_title: { richText: [] },
					ratings_lead_text: null,
					ratings_cta_text: null,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					predefined_ratings: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Highly rated in all the right places",
							spans: []
						}] },
						lead_text: null,
						cta_text: null,
						cta_link: {
							link_type: "Any",
							uid: null,
							type: null,
							lang: null,
							target: null,
							url: null
						},
						ratings: [
							{ rating: { document: { data: {
								logo: {
									alt: "G2 logo",
									copyright: "é",
									url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a49767c4-88c2-4b6f-ae3c-b236df9fbce6_G2_Logo_Red_RGB.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 150,
										width: 150
									}
								},
								rating_number: 4.8,
								link: "https://www.g2.com/products/pleo/reviews"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Capterra logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/ac82880a-40b6-43b9-975f-2f5d44310463_capterralogo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 345,
										width: 1500
									}
								},
								rating_number: 4.9,
								link: "https://www.capterra.co.uk/software/160720/pleo"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Xero Marketplace logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/4b26d78f-4a6c-485f-8260-6435a1299454_xero-connected.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 622,
										width: 1213
									}
								},
								rating_number: 5,
								link: "https://apps.xero.com/uk/app/pleo"
							} } } }
						]
					} } }
				},
				items: []
			},
			{
				__typename: "PrismicSlicePageDataBodyGetStarted",
				primary: {
					title: null,
					error_message: null,
					button_label: null,
					input_placeholder: null,
					form_subtitle: null,
					aria_label: null,
					form_production: null,
					form_staging: null,
					section_color: null,
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null
					},
					predefined_signup_banner: { document: {
						_previewable: "XymovhEAACYABewa",
						type: "signup_banner",
						data: {
							title: "Get started with Pleo",
							subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
							email_input_placeholder: "Your company email",
							email_input_error_text: "Please sign up with your company email",
							submit_text: "Get started",
							aria_label: "email",
							disclaimer_copy: { richText: [] },
							image: {
								alt: null,
								copyright: null,
								url: null,
								dimensions: null
							},
							redirect_link: {
								link_type: "Any",
								uid: null,
								type: null,
								lang: null,
								target: null,
								url: null
							},
							form_name: null,
							form_production: {
								formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
								consents: {
									type: "implicit_consent_to_process",
									communicationConsents: [{
										id: 5355469,
										required: false
									}]
								}
							},
							form_staging: {
								formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
								consents: {
									type: "explicit_consent_to_process",
									communicationConsents: [{
										id: 108196403,
										required: false
									}]
								}
							}
						}
					} }
				},
				items: []
			}
		],
		meta: {
			title: "",
			description: "",
			openGraphImageUrl: "https://images.prismic.io/commercial-helios/37ce2030-c715-4aa6-a4be-22fc43ca4eeb_Meta%20Image%20HR.jpg",
			canonicalLocation: "/us/for-agencies"
		}
	},
	{
		uid: "howitworks",
		slices: howitworksData.body,
		trackVisibleSections: howitworksData.track_visible_sections,
		meta: {
			title: "Automated expense management system",
			description: "Automate expense management with Pleo's software and smart app. Take full control of your business and employee spend with one online expense system.",
			openGraphImageUrl: "https://images.prismic.io/commercial-helios/c491d260-34fb-4366-a58e-7b27e81a552b_automated-expense-management-pleo.jpg",
			canonicalLocation: "/us/howitworks"
		}
	},
	{
		uid: "spend-controls",
		slices: [
			{
				__typename: "PrismicSlicePageDataBodyHero",
				primary: {
					section_html_id: null,
					title: "Full flexibility. Complete control.",
					inverse: false,
					is_oversized_image: false,
					lead_text: { richText: [{
						type: "paragraph",
						text: "Fine-tune your finances with custom spending limits, multi-step approvals and more. The best way to achieve perfect harmony between your projects and your spending.",
						spans: []
					}] },
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/e2940d23-d801-4ddf-a498-d0828d3eda17_01_Spend-control-hero.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1320,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/e2940d23-d801-4ddf-a498-d0828d3eda17_01_Spend-control-hero.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320",
									srcSet: "https://images.prismic.io/commercial-helios/e2940d23-d801-4ddf-a498-d0828d3eda17_01_Spend-control-hero.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=792 720w,\nhttps://images.prismic.io/commercial-helios/e2940d23-d801-4ddf-a498-d0828d3eda17_01_Spend-control-hero.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=1034 940w,\nhttps://images.prismic.io/commercial-helios/e2940d23-d801-4ddf-a498-d0828d3eda17_01_Spend-control-hero.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1188 1080w,\nhttps://images.prismic.io/commercial-helios/e2940d23-d801-4ddf-a498-d0828d3eda17_01_Spend-control-hero.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1320 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1320
						}
					},
					wistia_video_id: "1owuwj7n8r",
					video_mp4: { url: null },
					video_webm: { url: null },
					predefined_signup_banner: {
						type: "signup_banner",
						document: {
							_previewable: "XymovhEAACYABewa",
							type: "signup_banner",
							data: {
								title: "Get started with Pleo",
								subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
								email_input_placeholder: "Your company email",
								email_input_error_text: "Please sign up with your company email",
								submit_text: "Get started",
								aria_label: "email",
								disclaimer_copy: { richText: [] },
								image: {
									alt: null,
									copyright: null,
									url: null,
									dimensions: null
								},
								redirect_link: {
									link_type: "Any",
									uid: null,
									type: null,
									lang: null,
									target: null,
									url: null
								},
								form_name: null,
								form_production: {
									formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
									consents: {
										type: "implicit_consent_to_process",
										communicationConsents: [{
											id: 5355469,
											required: false
										}]
									}
								},
								form_staging: {
									formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
									consents: {
										type: "explicit_consent_to_process",
										communicationConsents: [{
											id: 108196403,
											required: false
										}]
									}
								}
							}
						}
					},
					predefined_proof_point_badges: { document: { data: {
						proof_point_first: [{
							title: "Leading expenses tool in Europe",
							subtitle: "1480+ five star reviews",
							icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/d66ae76f-7ded-4d70-90b7-a872c0368175_star-drawn.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 38,
									width: 38
								}
							}
						}],
						proof_point_second: [{
							title: "Bank-level security",
							subtitle: "FSA & PCI regulated",
							icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/dfad352e-ad1b-4c12-a52c-e1914befb5d3_padlock-drawn.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 43,
									width: 43
								}
							}
						}]
					} } }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyCustomers",
				primary: {
					title: null,
					predefined_logos: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Trusted by more than {{numberOfCustomers}} companies",
							spans: []
						}] },
						logos: [
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/b892536a-0265-45c4-8b84-4c9a2c3bb84a_soho%20house%20thickened-01.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 250
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/ef470c53-8f56-4448-b1e1-4080cf075bfc_Blinkist.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 150,
									width: 250
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/729c0a9d-23d6-426a-9973-d67c024ec6e1_hello%20fresh%20logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 320,
									width: 666
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/71f2f2a3-9db8-4131-98ed-1c05f5dbf52a_lyst%20logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 217,
									width: 692
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/0a6becfd-44ed-4e7b-970f-be70e7a2dd51_Unity_black.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 403,
									width: 1156
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/e5083805-f42d-44a4-ba53-5aca09498078_voi_logo%201.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 52,
									width: 124
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://commercial-helios.cdn.prismic.io/commercial-helios/9aac3bd8-5ac4-49f6-92b0-2ab07ff55e66_Too%20Good%20To%20Go.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 60,
									width: 100
								}
							} },
							{ icon: {
								alt: null,
								copyright: null,
								url: "https://images.prismic.io/commercial-helios/23b1da9c-4e97-4151-a2cf-a3b6e1421780_LIONS-logo-Black%20(1).png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
								dimensions: {
									height: 277,
									width: 896
								}
							} }
						]
					} } }
				},
				items: [{ logo: {
					alt: null,
					copyright: null,
					url: null,
					dimensions: null
				} }]
			},
			{
				__typename: "PrismicSlicePageDataBodySteps",
				primary: {
					title: "Spend controls at every corner",
					description: { richText: [{
						type: "paragraph",
						text: "Your personalised set of tools to help you hit your goals while keeping company spending in check.",
						spans: []
					}] },
					show_count: true,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_text: null
				},
				items: [
					{
						heading: "Permissions",
						content: "No more undesirable spending with our flexible permissions. Start by setting spending limits per month or per purchase. You can also choose how you reimburse your employees to take full control of your cash flow.",
						background_color: "muted",
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/e4a52814-c384-4c1b-a91a-a90f95a17774_Spend-control-permissions2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 1133,
								width: 1180
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/e4a52814-c384-4c1b-a91a-a90f95a17774_Spend-control-permissions2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133",
										srcSet: "https://images.prismic.io/commercial-helios/e4a52814-c384-4c1b-a91a-a90f95a17774_Spend-control-permissions2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=691 720w,\nhttps://images.prismic.io/commercial-helios/e4a52814-c384-4c1b-a91a-a90f95a17774_Spend-control-permissions2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=903 940w,\nhttps://images.prismic.io/commercial-helios/e4a52814-c384-4c1b-a91a-a90f95a17774_Spend-control-permissions2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1037 1080w,\nhttps://images.prismic.io/commercial-helios/e4a52814-c384-4c1b-a91a-a90f95a17774_Spend-control-permissions2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133 1180w",
										sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
									}
								},
								layout: "constrained",
								width: 1180,
								height: 1133
							}
						}
					},
					{
						heading: "Approvals",
						content: "Next, create transparent approval flows to make sure all your expenses are accounted for. Review and approve card expenses and reimbursements at a glance, or assign more reviewers to those that need an extra pair of eyes.",
						background_color: "muted",
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/e9f36771-fd97-47c7-b67a-af7da1e8778d_Spend-control-Approvals.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 1133,
								width: 1180
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/e9f36771-fd97-47c7-b67a-af7da1e8778d_Spend-control-Approvals.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133",
										srcSet: "https://images.prismic.io/commercial-helios/e9f36771-fd97-47c7-b67a-af7da1e8778d_Spend-control-Approvals.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=691 720w,\nhttps://images.prismic.io/commercial-helios/e9f36771-fd97-47c7-b67a-af7da1e8778d_Spend-control-Approvals.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=903 940w,\nhttps://images.prismic.io/commercial-helios/e9f36771-fd97-47c7-b67a-af7da1e8778d_Spend-control-Approvals.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1037 1080w,\nhttps://images.prismic.io/commercial-helios/e9f36771-fd97-47c7-b67a-af7da1e8778d_Spend-control-Approvals.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133 1180w",
										sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
									}
								},
								layout: "constrained",
								width: 1180,
								height: 1133
							}
						}
					},
					{
						heading: "Corrections",
						content: "Made an error? No problem. Our range of safeguards means you can easily freeze (or unfreeze) cards and prevent any suspicious spending. If an employee leaves the company,  just remove them as a Pleo user in four quick clicks.\xA0",
						background_color: "muted",
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/bd3581fb-61c4-4211-9a6a-24a647c7bd74_Spend-control-corrections-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 1133,
								width: 1180
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/bd3581fb-61c4-4211-9a6a-24a647c7bd74_Spend-control-corrections-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133",
										srcSet: "https://images.prismic.io/commercial-helios/bd3581fb-61c4-4211-9a6a-24a647c7bd74_Spend-control-corrections-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=691 720w,\nhttps://images.prismic.io/commercial-helios/bd3581fb-61c4-4211-9a6a-24a647c7bd74_Spend-control-corrections-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=903 940w,\nhttps://images.prismic.io/commercial-helios/bd3581fb-61c4-4211-9a6a-24a647c7bd74_Spend-control-corrections-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1037 1080w,\nhttps://images.prismic.io/commercial-helios/bd3581fb-61c4-4211-9a6a-24a647c7bd74_Spend-control-corrections-EN.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133 1180w",
										sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
									}
								},
								layout: "constrained",
								width: 1180,
								height: 1133
							}
						}
					},
					{
						heading: "Visibility",
						content: "At last, an easy way to visualise business spend in a way that works for you. Whether you want to keep an eye on budgeted spend or track different types of spend, Pleo does the work to give you the numbers you need, when you need them.",
						background_color: "muted",
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/a10aeffa-d34a-4bec-9555-a03755846e21_Spend-control-Visibility-spend-by-category.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 1133,
								width: 1180
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/a10aeffa-d34a-4bec-9555-a03755846e21_Spend-control-Visibility-spend-by-category.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133",
										srcSet: "https://images.prismic.io/commercial-helios/a10aeffa-d34a-4bec-9555-a03755846e21_Spend-control-Visibility-spend-by-category.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=691 720w,\nhttps://images.prismic.io/commercial-helios/a10aeffa-d34a-4bec-9555-a03755846e21_Spend-control-Visibility-spend-by-category.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=903 940w,\nhttps://images.prismic.io/commercial-helios/a10aeffa-d34a-4bec-9555-a03755846e21_Spend-control-Visibility-spend-by-category.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1037 1080w,\nhttps://images.prismic.io/commercial-helios/a10aeffa-d34a-4bec-9555-a03755846e21_Spend-control-Visibility-spend-by-category.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1180&h=1133 1180w",
										sizes: "(max-width: 767px) calc(100vw - 48px), (max-width: 1200px) calc(100vw / 2 - 48px), (max-width: 1439px) calc(100vw / 2 - 120px), 600px"
									}
								},
								layout: "constrained",
								width: 1180,
								height: 1133
							}
						}
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyMediaItemGrid",
				primary: {
					title: "Everything you need to feel in control",
					layout: "three_columns",
					background: "muted"
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/3905ece1-4b81-4f06-8ec4-4f1960d4e578_Customisable%20limits.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 100,
								width: 100
							}
						},
						item_title: "Customisable limits",
						item_description: { richText: [{
							type: "paragraph",
							text: "Personalise your spending limits, from total and monthly limits, to individual purchase and temporary limits.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/25ac7954-5b08-41d3-a45c-bc6175d70aaf_Pre%20block%20ATM%20withdrawals.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Pre-block ATM withdrawals",
						item_description: { richText: [{
							type: "paragraph",
							text: "Don’t want employees taking out cash? No problem – just block cash withdrawals in your settings.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/9ceeb1c2-efcc-4997-9741-dba4f6d55bf3_Flexible%20spending.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Flexible spending",
						item_description: { richText: [{
							type: "paragraph",
							text: "Anyone can be reimbursed for out-of-pocket expenses. Even those without a Pleo card.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/60f23315-3da8-4e14-8283-106f5d62dbe4_Reverse.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Fix errors",
						item_description: { richText: [{
							type: "paragraph",
							text: "If an employee makes a purchase with Pleo by mistake, they can change it by marking it as private in the app.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/7a084454-f710-41b0-9acf-fdfcbd42583d_Approvals.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Easy approvals",
						item_description: { richText: [{
							type: "paragraph",
							text: "Assign the right reviewers to approve each expense and invoice, so nothing falls through the cracks.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/5e352bb5-9b13-41ec-9950-07043f08c634_Freeze%20and%20remove%20users.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 65,
								width: 65
							}
						},
						item_title: "Freeze and remove users",
						item_description: { richText: [{
							type: "paragraph",
							text: "Lost your card or spotted something suspicious? Freeze cards or remove users in just a few clicks.",
							spans: []
						}] }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Choose your level of control",
					inverse: true,
					background: "default",
					headline: "Multi-step approvals",
					description: { richText: [{
						type: "paragraph",
						text: "When it comes to expenses, one size does not fit all. With Pleo, you can set different spend approval flows to suit your business and keep spending and reimbursements in check. Some expenses need extra attention? Choose different thresholds for reviewers to get another pair of eyes on certain purchases.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: null,
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/ac347e12-0db2-46e4-bde4-559c36f80320_Spend-control-exports-Choose-your-level-of-control-EN-GBP.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1200,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/ac347e12-0db2-46e4-bde4-559c36f80320_Spend-control-exports-Choose-your-level-of-control-EN-GBP.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200",
									srcSet: "https://images.prismic.io/commercial-helios/ac347e12-0db2-46e4-bde4-559c36f80320_Spend-control-exports-Choose-your-level-of-control-EN-GBP.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=720 720w,\nhttps://images.prismic.io/commercial-helios/ac347e12-0db2-46e4-bde4-559c36f80320_Spend-control-exports-Choose-your-level-of-control-EN-GBP.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=940 940w,\nhttps://images.prismic.io/commercial-helios/ac347e12-0db2-46e4-bde4-559c36f80320_Spend-control-exports-Choose-your-level-of-control-EN-GBP.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1080 1080w,\nhttps://images.prismic.io/commercial-helios/ac347e12-0db2-46e4-bde4-559c36f80320_Spend-control-exports-Choose-your-level-of-control-EN-GBP.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1200
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyFeatureBlock",
				primary: {
					title_over_section: null,
					title: "Stay on track with budgets",
					inverse: false,
					background: "default",
					headline: "New: Tag budgets",
					description: { richText: [{
						type: "paragraph",
						text: "Keep company spend neat and tidy thanks to budgets. Planning an event or monitoring a project and want to stay within budget? Just create a tag budget and assign all associated expenses to it. We’ll notify you when you’ve hit 75% and 100% of the budget, as well as if you go over it, so you can get a grip on your team’s spending.",
						spans: []
					}] },
					pre_cta_links: { richText: [] },
					is_circular_image: false,
					cta_label: null,
					predefined_feature_block: { document: null },
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					cta_hash_link: null,
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/b141a535-21ff-434e-b6fd-3f5995439029_Spend-control-event-budget-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1200,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/b141a535-21ff-434e-b6fd-3f5995439029_Spend-control-event-budget-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200",
									srcSet: "https://images.prismic.io/commercial-helios/b141a535-21ff-434e-b6fd-3f5995439029_Spend-control-event-budget-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=720 720w,\nhttps://images.prismic.io/commercial-helios/b141a535-21ff-434e-b6fd-3f5995439029_Spend-control-event-budget-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=940 940w,\nhttps://images.prismic.io/commercial-helios/b141a535-21ff-434e-b6fd-3f5995439029_Spend-control-event-budget-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1080 1080w,\nhttps://images.prismic.io/commercial-helios/b141a535-21ff-434e-b6fd-3f5995439029_Spend-control-event-budget-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1200
						}
					},
					wistia_video_id: null,
					video_mp4: { url: null },
					video_webm: { url: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodyMediaItemGrid",
				primary: {
					title: "Get the full picture",
					layout: "two_columns",
					background: "default"
				},
				items: [
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/7072d44a-8d6a-4140-8cdc-4b666a872b4b_Tags.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 100,
								width: 100
							}
						},
						item_title: "Tags & categories",
						item_description: { richText: [{
							type: "paragraph",
							text: "Employees can add tags and categories to expenses to give the finance team more context.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/c0a6c8ec-5c78-4fae-87be-1e872c7ad360_Budgets.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 100,
								width: 100
							}
						},
						item_title: "Budgets",
						item_description: { richText: [{
							type: "paragraph",
							text: "Knowing how much you can spend on a project or event is key to making sure you don’t overspend.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/ed192f0c-fac6-40a2-915e-ac518ab5b5d3_export%20b.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 150,
								width: 150
							}
						},
						item_title: "Exporting",
						item_description: { richText: [{
							type: "paragraph",
							text: "Easily export data to your main accounting system and view the approval status for each expense.",
							spans: []
						}] }
					},
					{
						image: {
							alt: null,
							copyright: null,
							url: "https://commercial-helios.cdn.prismic.io/commercial-helios/024f125d-faf4-44d1-a071-261cab8d5617_Analytics.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 100,
								width: 100
							}
						},
						item_title: "Analytics",
						item_description: { richText: [{
							type: "paragraph",
							text: "Track all the money your business is spending, from total receipts to the number of active Pleo users.",
							spans: []
						}] }
					}
				]
			},
			{
				__typename: "PrismicSlicePageDataBodyStats",
				primary: {
					first_stat_amount: 72,
					first_stat_text: "feel they have a better overview of how company money is being spent",
					first_stat_as_percentile: true,
					second_stat_amount: 75,
					second_stat_text: "agree Pleo has decreased time spent on admin work",
					second_stat_as_percentile: true,
					third_stat_amount: 69,
					third_stat_text: "feel that using Pleo has increased transparency",
					third_stat_as_percentile: true,
					source_text: { richText: [] },
					predefined_statistics: { document: null }
				}
			},
			{
				__typename: "PrismicSlicePageDataBodySocialProof",
				primary: {
					title: null,
					inverse: false
				},
				items: [{
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null,
						gatsbyImageData: null
					},
					quote: null,
					full_name: null,
					person_byline: null,
					predefined_testimonial: { document: { data: {
						image: {
							alt: null,
							copyright: null,
							url: "https://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
							dimensions: {
								height: 2240,
								width: 2400
							},
							gatsbyImageData: {
								images: {
									sources: [],
									fallback: {
										src: "https://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240",
										srcSet: "https://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=672 720w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=877 940w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1008 1080w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1440&h=1344 1440w,\nhttps://images.prismic.io/commercial-helios/aa4f81cf-b1d7-42be-ae12-004735008c8a_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=2400&h=2240 2400w",
										sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
									}
								},
								layout: "constrained",
								width: 2400,
								height: 2240
							}
						},
						quote: "With the controls we could implement and automatic reminders to employees when receipts were needed, we have been able to spend our time on so many more business-critical projects.",
						attribution_name: "Charlie Maynard",
						attribution_title: "Finance Manager, what3words"
					} } }
				}, {
					image: {
						alt: null,
						copyright: null,
						url: "https://images.prismic.io/commercial-helios/111a52c3-06a7-4357-bf66-175f9228065b_Planday-Kasper-Sommer.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 1200,
							width: 1200
						},
						gatsbyImageData: {
							images: {
								sources: [],
								fallback: {
									src: "https://images.prismic.io/commercial-helios/111a52c3-06a7-4357-bf66-175f9228065b_Planday-Kasper-Sommer.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200",
									srcSet: "https://images.prismic.io/commercial-helios/111a52c3-06a7-4357-bf66-175f9228065b_Planday-Kasper-Sommer.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=720 720w,\nhttps://images.prismic.io/commercial-helios/111a52c3-06a7-4357-bf66-175f9228065b_Planday-Kasper-Sommer.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=940 940w,\nhttps://images.prismic.io/commercial-helios/111a52c3-06a7-4357-bf66-175f9228065b_Planday-Kasper-Sommer.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1080 1080w,\nhttps://images.prismic.io/commercial-helios/111a52c3-06a7-4357-bf66-175f9228065b_Planday-Kasper-Sommer.jpeg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1200 1200w",
									sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
								}
							},
							layout: "constrained",
							width: 1200,
							height: 1200
						}
					},
					quote: "For traditional finance departments the idea of many people having a company credit card is a bit of a scary thought, but Pleo actually makes things a lot easier and safer.",
					full_name: "Kasper Sommer",
					person_byline: "Finance Director at Planday",
					predefined_testimonial: { document: null }
				}]
			},
			{
				__typename: "PrismicSlicePageDataBodyRatingsPlusHeadline",
				primary: {
					ratings_title: { richText: [] },
					ratings_lead_text: null,
					ratings_cta_text: null,
					cta_link: {
						link_type: "Any",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: null
					},
					predefined_ratings: { document: { data: {
						title: { richText: [{
							type: "paragraph",
							text: "Highly rated in all the right places",
							spans: []
						}] },
						lead_text: null,
						cta_text: null,
						cta_link: {
							link_type: "Any",
							uid: null,
							type: null,
							lang: null,
							target: null,
							url: null
						},
						ratings: [
							{ rating: { document: { data: {
								logo: {
									alt: "G2 logo",
									copyright: "é",
									url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a49767c4-88c2-4b6f-ae3c-b236df9fbce6_G2_Logo_Red_RGB.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 150,
										width: 150
									}
								},
								rating_number: 4.8,
								link: "https://www.g2.com/products/pleo/reviews"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Capterra logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/ac82880a-40b6-43b9-975f-2f5d44310463_capterralogo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 345,
										width: 1500
									}
								},
								rating_number: 4.9,
								link: "https://www.capterra.co.uk/software/160720/pleo"
							} } } },
							{ rating: { document: { data: {
								logo: {
									alt: "Xero Marketplace logo",
									copyright: null,
									url: "https://images.prismic.io/commercial-helios/4b26d78f-4a6c-485f-8260-6435a1299454_xero-connected.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
									dimensions: {
										height: 622,
										width: 1213
									}
								},
								rating_number: 5,
								link: "https://apps.xero.com/uk/app/pleo"
							} } } }
						]
					} } }
				},
				items: [{ rating: { document: null } }]
			},
			{
				__typename: "PrismicSlicePageDataBodyGetStarted",
				primary: {
					title: null,
					error_message: null,
					button_label: null,
					input_placeholder: null,
					form_subtitle: null,
					aria_label: null,
					form_production: null,
					form_staging: null,
					section_color: null,
					image: {
						alt: null,
						copyright: null,
						url: null,
						dimensions: null
					},
					predefined_signup_banner: { document: {
						_previewable: "XymovhEAACYABewa",
						type: "signup_banner",
						data: {
							title: "Get started with Pleo",
							subtitle: "Join {{numberOfCustomers}}+ customers already using Pleo to stay on top of company spending. Start your free trial.",
							email_input_placeholder: "Your company email",
							email_input_error_text: "Please sign up with your company email",
							submit_text: "Get started",
							disclaimer_copy: { richText: [] },
							aria_label: "email",
							image: {
								alt: null,
								copyright: null,
								url: null,
								dimensions: null
							},
							redirect_link: {
								link_type: "Any",
								uid: null,
								type: null,
								lang: null,
								target: null,
								url: null
							},
							form_name: null,
							form_production: {
								formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
								consents: {
									type: "implicit_consent_to_process",
									communicationConsents: [{
										id: 5355469,
										required: false
									}]
								}
							},
							form_staging: {
								formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
								consents: {
									type: "explicit_consent_to_process",
									communicationConsents: [{
										id: 108196403,
										required: false
									}]
								}
							}
						}
					} }
				},
				items: []
			}
		],
		meta: {
			title: "Spend controls at every corner",
			description: "Fine-tune your finances with custom spending limits, multi-step approvals and more. The best way to achieve perfect harmony between your projects and your spending.",
			openGraphImageUrl: "https://images.prismic.io/commercial-helios/4c64f8a0-2253-4391-8be1-ecf60a9ba04c_Spend-control-multi-step-approvals-alt.png",
			canonicalLocation: "/us/spend-controls"
		}
	}
];
//#endregion
//#region src/mappers/website/header.ts
const mapDropdown = (raw) => ({
	label: raw.label,
	href: raw.link.url ?? void 0,
	hideOn: raw.hide_on ?? "never",
	groups: raw.dropdown.document ? raw.dropdown.document.data.columns.map(({ column }) => ({
		label: column.document.data.label,
		links: column.document.data.links.map((link) => ({
			text: link.link_text,
			href: link.link.url
		})).filter((link) => link.href !== null)
	})) : void 0
});
const mapHeader = (raw) => ({
	logInText: raw.log_in,
	ctaButtonText: raw.start_free_trial,
	noResultsText: "No results found",
	items: raw.dropdowns.map(mapDropdown)
});
//#endregion
//#region src/namespaces/gatsby-client.ts
const GatsbyClient = {
	getHeader: () => {
		return header;
	},
	getFooter: () => {
		return footer;
	}
};
//#endregion
export { footer as a, header as i, mapHeader as n, slicePage as r, GatsbyClient as t };
